import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
  OnChanges,
  forwardRef,
} from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { OrderSummaryService } from "../../../../core/services/order-summary.service";
import buildQuery from "odata-query";
import { SaleOrderService } from "../../../../core/services/sale-order.service";
import {
  debounceTime,
  distinctUntilChanged,
  pluck,
  switchMap,
} from "rxjs/operators";
import { EMPTY, Observable, Subject, lastValueFrom } from "rxjs";
import { CopyHeaderComponent } from "../copy-header/copy-header.component";
import { v4 as uuidv4 } from "uuid";
import { OrderNotesSidebarComponent } from "../order-notes-sidebar/order-notes-sidebar.component";
import { OrderNotesGridComponent } from "../order-notes-grid/order-notes-grid.component";
import { CommonModule, DatePipe } from "@angular/common";
import { ConfirmationService, MenuItem } from "primeng/api";
import * as FileSaver from "file-saver";
import { OrderNotesSidebarService } from "../../../../core/services/order-notes-sidebar.service";
import { DialogModule } from "primeng/dialog";
import { TableModule } from "primeng/table";
import { FreightTrackingsDetailValue } from "../../../../core/models/invoice-preview/FreightTrackingsDetailValue";
import { Address } from "../../../../core/models/shared/address";
import { ApplyCreditCard } from "../../../../core/models/orders/applyCreditCard";
import { AssignOrderToProjectDto } from "../../../../core/models/orders/assignOrderToProjectDto";
import { CopyLinesDto } from "../../../../core/models/orders/copyLinesDto";
import { CopySalesOrderRequestDto } from "../../../../core/models/orders/copySalesOrderRequestDto";
import { CustomerPaymentMethodDto } from "../../../../core/models/orders/customerPaymentMethodDto";
import { GetAllBuyersRequestDto } from "../../../../core/models/orders/getAllBuyersRequestDto";
import { GetAllBuyersResponseDto } from "../../../../core/models/orders/getAllBuyersResponseDto";
import { GetBacForSalesOrderDto } from "../../../../core/models/orders/getBacForSalesOrderDto";
import { GetBCForSalesOrderDto } from "../../../../core/models/orders/getBCForSalesOrderDto";
import { GetExtisingPOIdRequest } from "../../../../core/models/orders/getExtisingPOIdRequest";
import { GetIRBillingReviewStatusResposne } from "../../../../core/models/orders/getIRBillingReviewStatusResposne";
import { InvoiceEmail } from "../../../../core/models/orders/invoicedEmail";
import { InvoicedEmailSummaryDto } from "../../../../core/models/orders/InvoicedEmailSummaryDto";
import { PoEmailData } from "../../../../core/models/orders/PoEmailData";
import { PreSalesProjectWorkflowList } from "../../../../core/models/orders/preSalesProjectWorkflowList";
import { PurchaseOrderIdDto } from "../../../../core/models/orders/purchaseOrderIdDto";
import { PrintPurchaseOrderDto } from "../../../../core/models/orders/purchaseOrderLine";
import { SalesOrderHeader } from "../../../../core/models/orders/saleOrderHeader";
import { SaleOrderHeaderAddressDto } from "../../../../core/models/orders/saleOrderHeaderAddressDto";
import { SalesOrderLine } from "../../../../core/models/orders/saleOrderLine";
import { SaleOrderLineAddressDto } from "../../../../core/models/orders/saleOrderLineAddressDto";
import { SaleOrderLinePortalKeyDto } from "../../../../core/models/orders/saleOrderLinePortalKeyDto";
import { SaleOrderResponseDto } from "../../../../core/models/orders/saleOrderResponseDto";
import { SalesOrderNotes } from "../../../../core/models/orders/salesOrderNotes";
import { UpdateSalesOrderHeaderDto } from "../../../../core/models/orders/updateSalesOrderHeaderDto";
import { Contact } from "../../../../core/models/shared/contact";
import { ShippingMethod } from "../../../../core/models/shared/shippingMethod";
import { ValidateLogin } from "../../../../core/models/validate-login.dto";
import { BuyerService } from "../../../../core/services/buyer.service";
import { CopyHeaderService } from "../../../../core/services/copy-header.service";
import { CustomerAccountService } from "../../../../core/services/customer-account.service";
import { InvoicePreviewSummaryService } from "../../../../core/services/invoice-preview-summary.service";
import { LoaderService } from "../../../../core/services/loader.service";
import { SamplepoListingService } from "../../../../core/services/samplepo-listing.service";
import { EnumCopiedFrom } from "../../../../shared/enums/copied-From.enum";
import { EnumOrderEmailState } from "../../../../shared/enums/orderEmailState.enum";
import { UserRole } from "../../../../shared/enums/userRoles.enum";
import { OrderTrackingComponent } from "../order-tracking/order-tracking.component";
import { UserManagementService } from "../../../../core/services/user-management.service";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { ClientSearchList } from "../../../../core/models/shared/clientSearchList";
import { GetD365DefaultProgramsAndSalesClassificationByClientResponse } from "../../../../core/models/program/getD365DefaultProgramsAndSalesClassificationByClientResponse";
import { ProgramClientListDto } from "../../../../core/models/program/programClientListDto";
import { QuotesLine } from "../../../../core/models/qoutes/quoteLine";
import { QuotesLinePortalKeyDto } from "../../../../core/models/qoutes/quotesLinePortalKeyDto";
import { AddressCountryRegion } from "../../../../core/models/shared/countryRegionList";
import { AddNewClientService } from "../../../../core/services/add-new-client.service";
import { ClientDetailsService } from "../../../../core/services/client-details.service";
import { ProgramsService } from "../../../../core/services/programs.service";
import { ShipToAddressComponent } from "../../../../shared/components/ship-to-address/ship-to-address.component";
import { EnumContactType } from "../../../../shared/enums/enumContactType";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DatePickerModule } from "primeng/datepicker";
import { Popover, PopoverModule } from "primeng/popover";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { OrderSummaryLineItemsReportComponent } from "../order-summary-line-items-report/order-summary-line-items-report.component";
import { FreightChargesComponent } from "../freight-charges/freight-charges.component";
import { PrintPurchaseOrderComponent } from "../print-purchase-order/print-purchase-order.component";
import { SummaryInvoiceEmailsComponent } from "../summary-invoice-emails/summary-invoice-emails.component";
import { OrderSummaryLineItemsComponent } from "../order-summary-line-items/order-summary-line-items.component";
import { PoEmailComponent } from "../po-email/po-email.component";
import { AddClientContact } from "../../../../core/models/client/addClientContact";
import { TrackingFreightApiRequestDto } from "../../../../core/models/invoice-review/trackingFreightApiRequestDto";
import { ProfileFormService } from "../../../../core/services/profile-form.service";
import { ExchangeRatesDto } from "../../../../core/models/shared/exchangeRateDto";
import { EnumModuleType } from "../../../../shared/enums/enumModuleType";
import { GenericResponseDto } from "../../../../core/models/generic-response.dto";
import { GetUserDto } from "../../../../core/models/users/users/getUserDto";
import { UsersList } from "../../../../core/models/users/users/usersList";
import { SelectChangeEvent, SelectModule } from "primeng/select";
import { CopyQuotesRequestDto } from "../../../../core/models/qoutes/copyQuotesRequestDto";
import { CreateSalesOrderEmailResponseDto } from "../../../../core/models/invoice-review/createSalesOrderEmailResponseDto";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { ButtonModule } from "primeng/button";
import { ToggleSwitchModule } from "primeng/toggleswitch";
import { AddContactInformationComponent } from "../../../clients/components/add-contact-information/add-contact-information.component";
import { ClientDetailsComponent } from "../../../clients/components/client-details/client-details.component";
import { MenuModule } from "primeng/menu";
import { Checkbox, CheckboxModule } from "primeng/checkbox";
import { CopyLinesDTOQuote } from "../../../../core/models/qoutes/CopyLinesDtoQuotes.dto";
import { QuotesLineAddressDto } from "../../../../core/models/qoutes/quotesLineAddressDto";
import { ReleasedProduct } from "../../../../core/models/shared/releaseProduct";
import { ReleasedProductVariants } from "../../../../core/models/shared/releasedProductVariants";
import { ClientAddressCustomize } from "../../../../core/models/client/details/clientAddresscustomize";
import { GetUserProjectDto } from "../../../../core/models/samplePO/details/getUserProjectDto";
import { ClientContact } from "../../../../core/models/client/details/clientContact";
import { ProgramComponent } from "../../../clients/components/program/program.component";
import { ProductionWorkflowSummaryComponent } from "../../../project-workflow/production-workflow-summary/production-workflow-summary.component";
import { ProgramListDto } from "../../../../core/models/program/programListDto";
import { FreightQuotationDetailComponent } from "../../../freight-quote/freight-quotation-detail/freight-quotation-detail.component";
import {
  computeMinDate,
  toDateOrNull,
} from "../../../../core/utilities/mindate-function";
import { InventoryLookupService } from "../../../../core/services/inventory-lookup.service";
import {
  JniStoreDto,
  InventoryWarehouseDto,
  InventoryOwnerDto,
} from "../../../../core/models/inventory/inventory-lookup.models";

import { environment } from "../../../../../environments/environment";
import { TooltipModule } from "primeng/tooltip";
@UntilDestroy()
@Component({
  selector: "jni-order-summary",
  templateUrl: "./order-summary.component.html",
  styleUrls: ["./order-summary.component.scss"],
  providers: [DatePipe, ConfirmationService],
  imports: [
    CommonModule,
    FormsModule,
    DialogModule,
    TableModule,
    OrderNotesSidebarComponent,
    ConfirmDialogModule,
    ReactiveFormsModule,
    DatePickerModule,
    SelectModule,
    PopoverModule,
    ShipToAddressComponent,
    ModalStackerComponent,
    OrderSummaryLineItemsReportComponent,
    OrderTrackingComponent,
    PoEmailComponent,
    FreightChargesComponent,
    PrintPurchaseOrderComponent,
    SummaryInvoiceEmailsComponent,
    CopyHeaderComponent,
    OrderSummaryLineItemsComponent,
    OrderNotesGridComponent,
    CardModule,
    InputTextModule,
    ButtonModule,
    ToggleSwitchModule,
    AddContactInformationComponent,
    ClientDetailsComponent,
    MenuModule,
    CheckboxModule,
    forwardRef(() => ProductionWorkflowSummaryComponent),
    ProgramComponent,
    FreightQuotationDetailComponent,
    Checkbox,
    CheckboxModule,
    TooltipModule,
  ],
})
export class OrderSummaryComponent implements OnInit, OnDestroy, OnChanges {
  @Input() saleOrderIdFromModal = "";
  @Input() orderType = "";

  @Output() clearShipToEvent = new EventEmitter();
  @Output() scrollHiddenStatus = new EventEmitter();
  @Output() smallLoaderEvent = new EventEmitter<boolean>();
  @Output() getBuyerEvent = new EventEmitter();
  @Output() customerBillToObjectEvent = new EventEmitter();
  @Output() closeOrderSummaryModalEvent = new EventEmitter();
  @Input() isModal = false;

  removedBacUser = "";
  buyerLists: GetAllBuyersResponseDto[] = [];
  collapseHeaderStatus = false;
  expandHeaderStatus = true;
  collapseHeaderHeading = "Collapse Header";

  collapseNotesStatus = false;
  expandNotesStatus = true;
  collapseNotesHeading = "Expand all";
  sharedMonthForView = new Date();

  saleOrderForm!: FormGroup;
  shipDate = "";
  inHandDate = "";
  saleOrderId = "";
  salesOrderLine: SaleOrderLineAddressDto[] = [];

  get headerSiteId(): string {
    return this.saleOrderForm?.get(["shipTo", "siteD365"])?.value ?? "";
  }

  get headerLocationId(): string {
    return this.saleOrderForm?.get(["shipTo", "locationD365"])?.value ?? "";
  }

  get headerStore(): string {
    return this.saleOrderForm?.get(["orderDetails", "store"])?.value ?? "";
  }

  get headerOwner(): string {
    return this.saleOrderForm?.get(["orderDetails", "owner"])?.value ?? "";
  }
  salesOrderLineReport: SaleOrderLineAddressDto[] = [];
  salesOrderLineQuote: QuotesLineAddressDto[] = [];
  showSmallLoader = false;
  pdfSmallLoader = false;
  salesOrderStatusD365 = "";
  approvalStatusD365 = "";
  applyFeeCardStatus = "";
  currencyConversion!: ExchangeRatesDto;
  subTotal = "";
  net = "";
  gp = 0;
  commission = 0;
  gpPercentage = 0;
  orderTotal = 0;
  netGp = 0;
  netGpPercentage = 0;
  percentageSign = "%";
  showAddress = false;
  loaderStatus = true;
  foreignCurrency = "";
  countryRegionList: AddressCountryRegion[] = [];
  customerBillToObject!: ClientSearchList;
  salesOrderHeaderData!: SaleOrderHeaderAddressDto;
  shippingProductsList: ShippingMethod[] = [];
  customerPaymentMethodList: CustomerPaymentMethodDto[] = [];
  hiddenShipDate = true;
  hiddenInHandDate = true;
  applyCreditCardStatus = true;
  addressFieldStatus = true;
  estimatedTaxStatus = true;
  estimatedFreightStatus = true;
  customerLists: ClientSearchList[] = [];
  selectedAccountNumber = "";
  creditfee = 0;
  oldEstimatedTax = 0;
  estimatedTax = 0;
  recommendedTax = 0;
  oldEstimatedFreight = 0;
  estimatedFreight = 0;
  releasedProductsList: ReleasedProduct[] = [];
  brandingConsultantLists: GetBCForSalesOrderDto[] = [];
  bcProjectId = "";
  bacProjectId = "";
  editHeaderStatus = false;
  updateButtonValidation = true;
  brandingConsultantObject!: GetBCForSalesOrderDto;
  shipDateCurrentdate!: Date;
  inHandDateCurrentdate!: Date;
  displayModal = false;
  invoiceEmail: InvoiceEmail[] = [];
  selectedInvoiceEmail: InvoiceEmail[] = [];
  freightChargeAmount = 0;
  bacUserDefaultSelectionId = "";
  salesOrderLines: SaleOrderLineAddressDto[] = [];
  purchaseOrderIdList: PurchaseOrderIdDto[] = [];
  public customerVendor$ = new Subject<string>();
  public buyerVendor$ = new Subject<string>();
  userPersonnelNumber!: string;
  bacList: GetBacForSalesOrderDto[] = [];
  smallLoader = false;
  displayEmailInvoiceModal = false;
  displaySidebar = false;
  isCustomerPoRequiredField = false;
  avaiableCredit = 0;
  getAvailableCreditBtnStatus = true;
  poExistFlag = false;
  clientDisplayModal = false;
  customerId = "";
  shiftToAddressList!: Address[];
  headerAddress!: Address;
  invoiceEmails: InvoiceEmail[] = [];
  bcPersonnelNumber = "";
  netCommissionStatus = false;
  printPdfModal = false;
  saleOrderModalStatus = false;
  isSaleOrderLineSync: SaleOrderLineAddressDto[] = [];
  isSaleOrderLineConfirmStatus = false;
  salesOrderLineDistinct: SaleOrderLineAddressDto[] = [];
  purchaseOrderLine: PrintPurchaseOrderDto[] = [];
  openPrinfPdfFlag = false;
  userObject!: GetUserDto;
  freightChargesDisplayModal = false;
  poEmailDisplayModal = false;
  poEmailData: PoEmailData = {} as PoEmailData;
  userBlockedFromEdit = false;
  buyerName = "";
  ClientAddresses: ClientAddressCustomize[] = [];
  clientContacts: Contact[] = [];
  displayAddContact = false;
  addClientContact: AddClientContact = {} as AddClientContact;
  customerAccountNumber = "";
  partyNumber = "";
  showCommissionsFields = true;
  proposalIdD365EditFieldValidation = false;
  sellCurrencyRate = 1;
  lineCurrencyRate = 1;
  displayIROrderStatusReview = false;
  getIRBillingReviewStatusResposne: GetIRBillingReviewStatusResposne =
    {} as GetIRBillingReviewStatusResposne;
  orderTrackingModalStatus = false;
  orderTrackingGridListing: FreightTrackingsDetailValue[] = [];
  orderTrackingGridListingExcel: FreightTrackingsDetailValue[] = [];
  releasedProductsVariantsList: ReleasedProductVariants[] = [];
  getD365DefaultProgramsAndSalesClassification =
    {} as GetD365DefaultProgramsAndSalesClassificationByClientResponse;
  customerAccountCopyCheck = "";
  customerFinancialDimension = "";

  salesId = "";
  projId = "";
  defaultTracking = "21";

  storeList: JniStoreDto[] = [];
  warehouseList: InventoryWarehouseDto[] = [];
  ownerList: InventoryOwnerDto[] = [];

  collapseOrderTrackingStatus = false;
  expandOrderTrackingStatus = true;
  collapseOrderTrackingHeading = "Expand all";

  showSeeAllButtonTracking = false;
  showProFormalDialog = false;
  showProFormalDialogHeading = "";
  reportType = "";
  isAnyUnCommitLines = false;
  showWorkflowDialog = false;
  isMelissaValidationIgnore = false;
  salesOrderProgramList: ProgramClientListDto[] = [];
  serviceFeeFromD365 = 0;
  showBacUserInputField = false;
  showCopyButton = false;

  @ViewChild("copyheader", { static: false })
  copyheader!: CopyHeaderComponent;

  @ViewChild("shipTo", { static: false })
  shipTo!: ShipToAddressComponent;

  @ViewChild("ordernotes", { static: false })
  ordernotes!: OrderNotesGridComponent;

  @ViewChild("ordernotessidebar", { static: false })
  ordernotessidebar!: OrderNotesSidebarComponent;

  @ViewChild("orderTracking", { static: false })
  orderTracking!: OrderTrackingComponent;

  applyCreditCardList: ApplyCreditCard[] = [
    {
      id: 0,
      name: "Client",
    },
    {
      id: 1,
      name: "BC Ledger",
    },
  ];
  deliveryAddress = [
    {
      id: 1,
      name: "One Time",
      status: false,
    },
    {
      id: 2,
      name: "Bill To",
      status: false,
    },
    {
      id: 3,
      name: "Client Address Book",
      status: false,
    },
    {
      id: 4,
      name: "Multi Ship To",
      status: false,
    },
    {
      id: 5,
      name: "TBD",
      status: false,
    },
  ];

  formErrors: Record<string, string> = {
    jobName: "",
    brandingConsultant: "",
    methodOfPayment: "",
    customerId: "",
    shipDate: "",
    inHandsDate: "",
    addressSelectionName: "",
    countryRegionIdD365: "",
    customerPONumber: "",
    deliveryNameD365: "",
    store: "",
    warehouse: "",
  };

  validationMessages: Record<string, Record<string, string>> = {
    jobName: {
      required: "Job name is required.",
      minlength: "Job name must be greater than 2 characters.",
      maxlength: "Job name must be less than 300 characters.",
    },
    brandingConsultant: {
      required: "Branding consultant is required.",
      minlength: "Job name must be greater than 2 characters.",
      maxlength: "Job name must be less than 50 characters.",
    },
    accountsCoordinator: {
      required: "Accounts coordinator is required.",
    },
    methodOfPaymentHeader: {
      required: "Payment method is required.",
    },
    customerId: {
      required: "Client account is required.",
    },
    shipDate: {
      required: "Ship date is required.",
    },
    inHandsDate: {
      required: "In-Hands date is required.",
    },
    addressSelectionName: {
      required: "Delivery is required.",
    },
    countryRegionIdD365: {
      required: "Country is required.",
    },
    customerPONumber: {
      required: "Client PO Number is required.",
    },
    deliveryNameD365: {
      maxlength: "Name must be less than 100 characters.",
    },
    store: {
      required: "Store is required.",
    },
    warehouse: {
      required: "Warehouse is required.",
    },
  };
  editStatus!: string;
  backgroundColor = "#FAFAFA";
  programName = "";

  @ViewChild("programs", { static: true })
  programs!: ProgramComponent;

  isLineEditDisabled = false;
  isEditButtonVisible = false;
  hideButtonsOnPageLoad = true;
  isPartiallyInvoicedOrderLines = false;
  invoiceProposalExists = "";
  fromOrderSummary = false;
  envData = environment;
  showProjectOption = false;
  showProjectAssignDailog = false;
  preSalesProjectList: PreSalesProjectWorkflowList[] = [];
  projectWorkflowId = 0;
  paddedProjectWorkflowId = "";
  workflowAssigned = false;
  showAllOrderNotes = false;
  projectHasUnsavedChanges = false;
  saleOrderData = {} as SaleOrderResponseDto;
  items: MenuItem[] = [];
  showFreightEstimationModule = false;
  jobName = "";
  selectedLineItems: SaleOrderLineAddressDto[] = [];

  constructor(
    private _fb: FormBuilder,
    private _toastr: JniToastrService,
    private route: ActivatedRoute,
    private _loaderService: LoaderService,
    private _orderSummaryService: OrderSummaryService,
    private _customerAccountService: CustomerAccountService,
    private _samplepoListingService: SamplepoListingService,
    private _addNewClientService: AddNewClientService,
    private _saleOrderService: SaleOrderService,
    private _profileFormService: ProfileFormService,
    private _clientDetailsService: ClientDetailsService,
    private _loginService: UserManagementService,
    private router: Router,
    public datepipe: DatePipe,
    private confirmationService: ConfirmationService,
    private _copyLinesService: CopyHeaderService,
    private renderer: Renderer2,
    private _buyerService: BuyerService,
    private _invoicePreviewSummaryService: InvoicePreviewSummaryService,
    private _programService: ProgramsService,
    public _orderNotesSidebarService: OrderNotesSidebarService,
    private _inventoryLookupService: InventoryLookupService
  ) {
    this.initializeForm();
    this.route.params.subscribe(params => {
      this.saleOrderId = params["id"];
    });
    if (this.router.getCurrentNavigation()?.extras?.state?.["orderType"]) {
      this.orderType =
        this.router.getCurrentNavigation()?.extras?.state?.["orderType"];
    }
  }

  ngOnInit(): void {
    if (this.saleOrderId) {
      this.getMehtodPaymentListData();
      this.getAllBuyers();
      this.getSaleOrderHeaderData(this.loaderStatus);
      this.getSaleOrderLinesData();
      this.getIRBillingReviewStatus();
      this.getSalesOrderInvoiceEmails();
      this.disabledSaleOrderHeaderFields();
      //this.getCountryRegionListData(); //OptimzationWork 27-02-2025 removed and API opened
      //this.getMehtodPaymentListData(); //OptimzationWork 27-02-2025 removed and API opened
      this.searchCustomerName();
      //this.getAllReleaseProduct(); //OptimizationWork: deferred to inline row edit
      //this.getAllVariants(); //optimization work
      this.getStateOfCollapseAll();
      //this.getNotesStateOfCollapseAll(); //OptimzationWork 27-02-2025
      this.getUserProfile();
      this.getFreightChargesData();
      this.IsUserBlockedFromEdit();
      this.searchBuyerName();

      this.IsSalesOrderInvoiced();
      this.getSalesOrderAssignedProject();
    }
  }

  ngOnChanges() {
    if (this.saleOrderIdFromModal) {
      this.saleOrderId = this.saleOrderIdFromModal;
      this.saleOrderModalStatus = true;
      this.populateMenuItem();
    }
  }

  private initializeForm() {
    this.saleOrderForm = this._fb.group({
      orderHeader: this._fb.group({
        customerId: ["", Validators.required],
        jobName: ["", Validators.required],
        inHandsDate: ["", Validators.required], //inhands
        shipDate: [""],
        methodOfPaymentHeader: ["", Validators.required],
        brandingConsultant: ["", Validators.required],
        accountsCoordinator: ["", Validators.required], // account co-ordinator
        buyer: [""],
        programId: [""],
        programDimensions: [""],
      }),
      customerAddress: this._fb.group({
        name: [""],
        address: [""],
        telephone: [""],
        billingAttentionD365: [""],
        billingLocationD365: [""],
      }),
      shipTo: this._fb.group({
        deliveryAddress: [""],
        attention: [""],
        countryRegionIdD365: ["", Validators.required],
        zipCodeD365: [""],
        cityD365: [""],
        stateD365: [""],
        addressD365: [""],
        streetD365: ["", Validators.required],
        purposeD365: [""],
        isPrimaryD365: "1",
        rSMJNIShipToEmailD365: [""],
        addressBook: [""],
        buildingComplimentD365: [""],
        apartment_RUD365: [""],
        postBoxD365: [""],
        countyD365: [""],
        streetNumberD365: [""],
        districtNameD365: [""],
        saveAddress: [false],
        attentionInformationD365: [""],
        siteD365: [""],
        addressSelectionName: ["", Validators.required],
        locationD365: [""],
        addressLocationNumber: 0,
        addressFormat: [""],
        validateAddress: [""],
        melissaAddressKeyD365: [""],
        addressLine1: [""],
        addressLine2: [""],
        addressLine3: [""],
        deliveryNameD365: ["", Validators.maxLength(100)],
      }),
      orderDetails: this._fb.group({
        // buyer: [''],
        shippingMethod: [""],
        account: [""],
        foreignCurrency: [""],
        customerPONumber: [""],
        shippingMethodName: [""],
        creditCardFeeCharge: 0,
        methodOfPayment: [""],
        foreignCurrencyStatus: [false],
        jniSalesInventoryD365: [{ value: false, disabled: true }],
        store: [""],
        warehouse: [""],
        site: [{ value: "", disabled: true }],
        owner: [{ value: "", disabled: true }],
      }),
      estimatedOrderTotals: this._fb.group({
        recommendedTax: [0],
        estimatedTax: [0],
        estimatedFreight: [0],
        orderTotal: [0],
        invoiceEmail: [""],
        initiateShipment: [""],
      }),
      invoicedEmail: this._fb.array([]),
    });
  }

  logValidationErrors(group: FormGroup = this.saleOrderForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = "";
        if (
          abstractControl &&
          !abstractControl.valid &&
          (abstractControl.touched || abstractControl.dirty)
        ) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey && messages) {
              this.formErrors[key] += messages[errorKey] + " ";
            }
          }
        }
      }
    });
  }

  getAllBcUsers(bcname: string, bacname: string) {
    this._samplepoListingService
      .getAllBrandingConsultant()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: GenericResponseDto<GetUserProjectDto[]>) => {
          if (res.data) {
            this.brandingConsultantLists = res.data;
            const bcObject = res.data.filter(
              (x: GetUserProjectDto) => x.personnelNumber === bcname
            );
            if (bcObject.length > 0) {
              this.bcProjectId = bcObject[0].personnelNumber;
              this.saleOrderForm.patchValue({
                orderHeader: {
                  brandingConsultant: bcObject[0].projectName,
                },
              });
              this.getBACList(bcObject[0].id, bacname);
            }
          }
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  getBACList(id: number, bacname: string) {
    this._orderSummaryService
      .getBACList(id)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: GenericResponseDto<UsersList[]>) => {
          if (res.data) {
            this.bacList = res.data as unknown as GetBacForSalesOrderDto[];
            const bac = res.data.filter(
              (x: UsersList) => x.personnelNumber === bacname
            );
            if (bac.length > 0) {
              this.bacProjectId = bac[0].personnelNumber;
              this.bacUserDefaultSelectionId = this.bacProjectId;
            }
          }
        },
      });
  }

  getCountryRegionListData() {
    this._addNewClientService
      .getCountryRegionList()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.countryRegionList = res?.data;
        },
      });
  }

  getLoaderStatus(status: boolean) {
    this.showSmallLoader = status;
  }

  disabledSaleOrderHeaderFields() {
    this.saleOrderForm.get(["orderHeader", "buyer"])?.disable();
    //this.saleOrderForm.get(['orderHeader', 'customerId'])?.disable();
    this.saleOrderForm.get(["orderHeader", "jobName"])?.disable();
    this.saleOrderForm.get(["orderHeader", "brandingConsultant"])?.disable();
    this.saleOrderForm.get(["orderHeader", "accountsCoordinator"])?.disable();
    this.saleOrderForm.get(["orderHeader", "shipDate"])?.disable();
    this.saleOrderForm.get(["orderHeader", "inHandsDate"])?.disable();
    this.saleOrderForm.get(["orderHeader", "methodOfPaymentHeader"])?.disable();
    this.saleOrderForm.get(["orderHeader", "programId"])?.disable();
    //this.saleOrderForm.get(['customerAddress', 'name'])?.disable();
    //this.saleOrderForm.get(['customerAddress', 'address'])?.disable();
    this.saleOrderForm.get(["customerAddress", "telephone"])?.disable();
    this.saleOrderForm
      .get(["customerAddress", "billingAttentionD365"])
      ?.disable();
    this.saleOrderForm
      .get(["customerAddress", "billingLocationD365"])
      ?.disable();

    this.saleOrderForm.get(["shipTo", "addressSelectionName"])?.disable();
    this.saleOrderForm.get(["shipTo", "attentionInformationD365"])?.disable();
    this.saleOrderForm.get(["shipTo", "streetD365"])?.disable();
    this.saleOrderForm.get(["shipTo", "locationD365"])?.disable();
    this.saleOrderForm.get(["shipTo", "countryRegionIdD365"])?.disable();
    this.saleOrderForm.get(["shipTo", "zipCodeD365"])?.disable();
    this.saleOrderForm.get(["shipTo", "addressFormat"])?.disable();
    this.saleOrderForm.get(["shipTo", "addressD365"])?.disable();
    this.saleOrderForm.get(["shipTo", "rSMJNIShipToEmailD365"])?.disable();
    this.saleOrderForm.get(["shipTo", "buildingComplimentD365"])?.disable();
    this.saleOrderForm.get(["shipTo", "deliveryNameD365"])?.disable();

    // this.saleOrderForm.get(['orderDetails', 'buyer'])?.disable();
    this.saleOrderForm.get(["orderDetails", "customerPONumber"])?.disable();
    this.saleOrderForm.get(["orderDetails", "shippingMethod"])?.disable();
    this.saleOrderForm.get(["orderDetails", "foreignCurrency"])?.disable();
    this.saleOrderForm.get(["orderDetails", "creditCardFeeCharge"])?.disable();
    this.saleOrderForm.get(["orderDetails", "shippingMethodName"])?.disable();
    this.saleOrderForm.get(["orderDetails", "store"])?.disable();
    this.saleOrderForm.get(["orderDetails", "warehouse"])?.disable();
    this.saleOrderForm.get(["orderDetails", "owner"])?.disable();

    this.saleOrderForm
      .get(["estimatedOrderTotals", "recommendedTax"])
      ?.disable();
    this.saleOrderForm.get(["estimatedOrderTotals", "orderTotal"])?.disable();
    this.saleOrderForm.get(["estimatedOrderTotals", "invoiceEmail"])?.disable();
    //this.saleOrderForm.get(['orderHeader', 'customerId'])?.disable();
    this.addressFieldStatus = false;
    this.updateButtonValidation = true;
    this.estimatedTaxStatus = true;
    this.estimatedFreightStatus = true;
    this.hiddenShipDate = true;
    this.hiddenInHandDate = true;
    this.programs.disableEnableProgram(true);
  }

  shippingMethodD365 = "";
  lastModifiedDate = "";
  createdDate = "";
  lastModifiedName = "";
  createdDateName = "";
  patchValuesInSaleOrderHeader(orderheader: SalesOrderHeader) {
    this.saleOrderForm.patchValue({
      orderHeader: {
        customerId: orderheader.customerIdD365,
        jobName: orderheader.jobNameD365,
        brandingConsultant: orderheader.brandingConsultantD365,
        accountsCoordinator: orderheader.accountsCoordinatorD365,
        methodOfPaymentHeader: orderheader.methodOfPaymentD365,
        buyer: orderheader.buyerD365,
        programId: orderheader.programId,
      },
      orderDetails: {
        shippingMethod: orderheader.shippingMethodD365,
        foreignCurrency: orderheader.foreignCurrencyD365,
        customerPONumber: orderheader.customerPONumberD365,
        shippingMethodName: orderheader.shippingMethodName,
        jniSalesInventoryD365: orderheader.jniSalesInventoryD365,
        store: orderheader.storeD365 ?? "",
        warehouse:
          orderheader.warehouseD365 ?? orderheader.inventLocationIdD365 ?? "",
        site: orderheader.siteD365 ?? "",
        owner: orderheader.ownerD365 ?? "",
        account: orderheader.account,
      },
      customerAddress: {
        billingAttentionD365: orderheader.billToAttentionInformationD365,
        billingLocationD365: orderheader.billToLocationD365,
      },
      estimatedOrderTotals: {
        initiateShipment: orderheader.initiateShipmentCycle,
      },
    });

    this.bcPersonnelNumber = orderheader?.brandingConsultantD365 ?? "";
    this.netCommissionVisibleForBC(this.userObject);
    this.creditfee = orderheader.creditCardFeeChargeD365;
    this.shippingMethodD365 = orderheader.shippingMethodD365 ?? "";
    if (this.shippingProductsList?.length <= 0) {
      this.getAllShippingMethod(); //optimization work
    }
    this.getCreditCard({
      value: orderheader.methodOfPaymentD365 ?? "",
    } as SelectChangeEvent);
    if (orderheader.lastModifiedDate) {
      this.lastModifiedDate = orderheader.lastModifiedDate;
      const modifiedNameList = orderheader?.lastModifiedBy?.split("@");
      if (modifiedNameList && modifiedNameList?.length > 1) {
        this.lastModifiedName = modifiedNameList[0];
      }
    }
    if (orderheader.createdDate) {
      this.createdDate = orderheader.createdDate;
      const createdByList = orderheader?.createdBy.split("@");
      if (createdByList.length > 1) {
        this.createdDateName = createdByList[0];
      }
    }

    this.programs.programId = orderheader?.programId ?? 0;

    if (orderheader?.programId && orderheader?.programId > 0) {
      //this.getProgramNameById(orderheader?.programId ?? 0); OptimzationWork 27-02-2025
    }
    // this.getAllBuyers(); OptimzationWork 27-02-2025
    //this.getCustomerAccountDefaultDimensions(orderheader.customerIdD365); // OptimzationWork 27-02-2025
    //this.getAllProgramsByCustomer(orderheader.customerIdD365); // OptimzationWork 27-02-2025
  }

  loadInventoryLookups(): void {
    this.saleOrderForm
      .get(["orderDetails", "store"])
      ?.setValidators(Validators.required);
    this.saleOrderForm.get(["orderDetails", "store"])?.updateValueAndValidity();
    this.saleOrderForm
      .get(["orderDetails", "warehouse"])
      ?.setValidators(Validators.required);
    this.saleOrderForm
      .get(["orderDetails", "warehouse"])
      ?.updateValueAndValidity();

    // Get DB-populated values first
    const warehouse = this.saleOrderForm.get([
      "orderDetails",
      "warehouse",
    ])?.value;
    const store = this.saleOrderForm.get(["orderDetails", "store"])?.value;
    const currentSite = this.saleOrderForm.get(["orderDetails", "site"])?.value;
    const currentOwner = this.saleOrderForm.get([
      "orderDetails",
      "owner",
    ])?.value;

    // Load dropdown lists
    this._inventoryLookupService
      .getStores()
      .pipe(untilDestroyed(this))
      .subscribe(res => {
        if (res.data) this.storeList = res.data;
      });
    this._inventoryLookupService
      .getWarehouses()
      .pipe(untilDestroyed(this))
      .subscribe(res => {
        if (res.data)
          this.warehouseList = res.data.filter(
            w => w.inventoryWarehouseD365 === "Yes"
          );
      });

    // Site: use DB value if available, else derive from warehouse
    if (warehouse && !currentSite) {
      this._inventoryLookupService
        .getSiteByWarehouse(warehouse)
        .pipe(untilDestroyed(this))
        .subscribe(res => {
          this.saleOrderForm
            .get(["orderDetails", "site"])
            ?.setValue(res.data ?? "");
        });
    }

    // Owner: load options list if store+warehouse available
    if (store && warehouse) {
      this._inventoryLookupService
        .getOwnersByStoreAndWarehouse(store, warehouse)
        .pipe(untilDestroyed(this))
        .subscribe(res => {
          if (res.data) {
            this.ownerList = res.data;
            // If DB owner not in list, add it so dropdown displays it
            if (
              currentOwner &&
              !res.data.some(o => o.ownerD365 === currentOwner)
            ) {
              this.ownerList = [{ ownerD365: currentOwner }, ...this.ownerList];
            }
          }
        });
    } else if (currentOwner) {
      // Owner from DB but can't load full list - add to list for display
      this.ownerList = [{ ownerD365: currentOwner }];
    }
  }

  onStoreChange(): void {
    const store = this.saleOrderForm.get(["orderDetails", "store"])?.value;
    const warehouse = this.saleOrderForm.get([
      "orderDetails",
      "warehouse",
    ])?.value;
    this.refreshOwners(store, warehouse);
  }

  onWarehouseChange(warehouseId: string): void {
    if (warehouseId) {
      this._inventoryLookupService
        .getSiteByWarehouse(warehouseId)
        .pipe(untilDestroyed(this))
        .subscribe(res => {
          this.saleOrderForm
            .get(["orderDetails", "site"])
            ?.setValue(res.data ?? "");
        });
    } else {
      this.saleOrderForm.get(["orderDetails", "site"])?.setValue("");
    }
    const store = this.saleOrderForm.get(["orderDetails", "store"])?.value;
    this.refreshOwners(store, warehouseId);
  }

  refreshOwners(store: string, warehouse: string): void {
    const ownerCtrl = this.saleOrderForm.get(["orderDetails", "owner"]);
    if (store && warehouse) {
      if (this.editHeaderStatus) {
        ownerCtrl?.enable();
      }
      this._inventoryLookupService
        .getOwnersByStoreAndWarehouse(store, warehouse)
        .pipe(untilDestroyed(this))
        .subscribe(res => {
          this.ownerList = res.data ?? [];
          const currentOwner = ownerCtrl?.value;
          if (!this.ownerList.some(o => o.ownerD365 === currentOwner)) {
            ownerCtrl?.setValue("");
          }
        });
    } else {
      ownerCtrl?.disable();
      ownerCtrl?.setValue("");
      this.ownerList = [];
    }
  }

  patchValuesInSaleOrderHeaderAddress(
    orderHeaderAddress: Address,
    orderHeader: SalesOrderHeader
  ) {
    // ToDO the code if address lines needed to show
    // if(orderHeaderAddress.countryRegionIdD365 !== 'USA'){
    //   this.shipTo.onCountryRegionSelection(orderHeaderAddress.countryRegionIdD365 ?? '') ;
    //   this.shipTo.disabledAddressFields();
    //   this.shipTo.showAddressLinesFields = true;
    // }

    this.saleOrderForm.patchValue({
      shipTo: {
        //addressSelectionName: orderHeader.addressSelectionD365,
        streetD365: orderHeaderAddress.streetD365,
        attentionInformationD365: orderHeader.attentionInformationD365,
        rSMJNIShipToEmailD365: orderHeader.rsmjniShipToEmail,
        locationD365: orderHeader.locationD365,
        countryRegionIdD365: orderHeaderAddress.countryRegionIdD365,
        zipCodeD365: orderHeaderAddress.zipCodeD365,
        cityD365: orderHeaderAddress.cityD365,
        stateD365: orderHeaderAddress.stateD365,
        buildingComplimentD365: orderHeaderAddress.buildingComplimentD365,
        postBoxD365: orderHeaderAddress.postBoxD365,
        countyD365: orderHeaderAddress.countyD365,
        streetNumberD365: orderHeaderAddress.streetNumberD365,
        districtNameD365: orderHeaderAddress.districtNameD365,
        deliveryNameD365: orderHeader.deliveryNameD365,
        addressLocationNumber: orderHeader?.addressLocationNumberD365 ?? 0,
        addressD365: orderHeaderAddress?.addressD365?.replace("<br/>", "\n"),
      },
    });
    this.patchValueInaddressSelection(orderHeader.addressSelectionD365 ?? "");
    this.getOneTimeAddress();
  }

  patchValueInaddressSelection(addressSelectionName: string) {
    let addressBook = "";
    if (addressSelectionName.toLowerCase().includes("address book")) {
      addressBook = "Client Address Book";
      this.shipTo.shipToAddress = true;
      this.shipTo.clientShipToAddressDisabled = true;
    } else if (addressSelectionName.toLowerCase().includes("bill to")) {
      addressBook = "Bill To";
      this.shipTo.billToFieldName = true;
    } else if (addressSelectionName.toLowerCase().includes("one time")) {
      addressBook = "One Time";
    } else if (
      addressSelectionName.toLowerCase().includes("multi ship") ||
      addressSelectionName.toLowerCase().includes("multi") ||
      addressSelectionName.toLowerCase().includes("drop")
    ) {
      addressBook = "Multi Ship To";
    } else if (addressSelectionName.toLowerCase().includes("tbd")) {
      addressBook = "TBD";
    } else {
      addressBook = addressSelectionName;
    }
    this.saleOrderForm.patchValue({
      shipTo: {
        addressSelectionName: addressBook,
      },
    });
  }

  patchValuesInInvoiceEmail(invoiceEmail: InvoiceEmail[]) {
    this.invoiceEmails = invoiceEmail;
    let commonSeparatedEmail = "";
    this.invoiceEmail = [];
    invoiceEmail.forEach(x => {
      if (x.invoice) {
        this.invoiceEmail.push(x);
      }
    });
    invoiceEmail.forEach(x => {
      if (x.invoice) {
        commonSeparatedEmail += x.email + "\n";
      }
    });
    if (commonSeparatedEmail) {
      this.saleOrderForm.patchValue({
        estimatedOrderTotals: {
          invoiceEmail: commonSeparatedEmail.slice(0, -1),
        },
      });
    }

    const frmArray = this.saleOrderForm.get("invoicedEmail") as FormArray;
    frmArray.clear();

    this.invoiceEmail.forEach(x => {
      this.addInvoiceEmail({
        electronicAddressIdD365: uuidv4(),
        name: x.name || "",
        purpose: x.purpose || "",
        email: x.email,
        exist: x.exist,
        invoice: x.invoice,
        confirmation: x.confirmation,
        save: x.save,
        salesOrderIdD365: x.salesOrderIdD365,
        id: x.id,
        invoiceEmailRecIdD365: x.invoiceEmailRecIdD365,
      });
    });
    this.disableSaveAndExisitInvoiceEmail();
    this.disabledInvoiceEmail();
  }

  private disableSaveAndExisitInvoiceEmail() {
    (this.saleOrderForm.get("invoicedEmail") as FormArray).controls.forEach(
      group => {
        (group.get("save") as FormControl).disable();
        (group.get("exist") as FormControl).disable();
      }
    );
  }

  addInvoiceEmail(
    invoicedEmail: InvoicedEmailSummaryDto = {
      electronicAddressIdD365: uuidv4(),
      exist: false,
      invoice: false,
      save: false,
      confirmation: false,
      email: "",
      name: "",
      purpose: "",
      salesOrderIdD365: "",
      id: 0,
      invoiceEmailRecIdD365: 0,
    }
  ) {
    const control = this.saleOrderForm.get("invoicedEmail") as FormArray;
    control.push(this.createInvoiceEmail(invoicedEmail));
    this.disableExisitInvoiceEmail();
  }

  createInvoiceEmail(invoicedEmail: InvoicedEmailSummaryDto) {
    return this._fb.group({
      electronicAddressIdD365:
        invoicedEmail.electronicAddressIdD365 || uuidv4(),
      name: invoicedEmail.name || "",
      purpose: invoicedEmail.purpose || "",
      email: invoicedEmail.email || "",
      confirmation: invoicedEmail.confirmation,
      exist: invoicedEmail.exist,
      invoice: invoicedEmail.invoice,
      save: invoicedEmail.save,
      id: invoicedEmail.id,
      salesOrderIdD365: invoicedEmail.salesOrderIdD365,
      invoiceEmailRecIdD365: invoicedEmail.invoiceEmailRecIdD365,
    } as InvoicedEmailSummaryDto);
  }

  addNewLine(event: boolean) {
    if (event) {
      const invoicedEmail: InvoicedEmailSummaryDto = {
        electronicAddressIdD365: uuidv4(),
        exist: false,
        invoice: false,
        save: false,
        confirmation: false,
        email: "",
        name: "",
        purpose: "",
        id: 0,
        salesOrderIdD365: "",
        invoiceEmailRecIdD365: 0,
      };
      const control = this.saleOrderForm.get("invoicedEmail") as FormArray;
      control.insert(0, this.createInvoiceEmail(invoicedEmail));
      this.disableExisitInvoiceEmail();
      //this.addInvoiceEmail();
    }
  }

  removeEmail(formgroup: FormGroup[]) {
    formgroup.forEach(x => {
      const value = x.get("electronicAddressIdD365")?.value;
      for (
        let i = 0;
        i < (this.saleOrderForm.get("invoicedEmail") as FormArray).length;
        i++
      ) {
        if (
          (this.saleOrderForm.get("invoicedEmail") as FormArray)
            .at(i)
            .get("electronicAddressIdD365")?.value == value
        ) {
          (this.saleOrderForm.get("invoicedEmail") as FormArray).removeAt(i--);
        }
      }
    });
  }

  private disableExisitInvoiceEmail() {
    (this.saleOrderForm.get("invoicedEmail") as FormArray).controls.forEach(
      group => {
        (group.get("exist") as FormControl).disable();
      }
    );
  }

  orderTotalD365 = 0;

  getSaleOrderHeaderData(getloaderStatus: boolean) {
    if (this.saleOrderId) {
      this._loaderService.setLoaderState(getloaderStatus);
      this._orderSummaryService
        .getSaleOrderHeaderData(this.saleOrderId)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            if (!this.saleOrderModalStatus) {
              this._loaderService.setLoaderState(false);
            }

            if (res.data) {
              // const odataFilter = `?$filter=ID eq '${this.saleOrderId}' or ID eq '${res.data.salesOrderHeader?.salesOrderHeader?.customerIdD365}'`;
              // this._orderSummaryService
              //   .GetJNIDeletedRecordsFilter(odataFilter)
              //   .subscribe();
              if (res?.data?.salesOrderHeader) {
                this.salesOrderHeaderData = res.data.salesOrderHeader;
              }

              if (this.salesOrderHeaderData?.salesOrderHeader?.feeCharges) {
                this.serviceFeeFromD365 =
                  this.salesOrderHeaderData.salesOrderHeader.feeCharges /
                  100; /*As per the ticket need to divide the service fee by 100 #12953 */
              }

              if (res.data.salesOrderHeader?.address) {
                this.headerAddress = res?.data?.salesOrderHeader?.address;
              }
              if (res.data.salesOrderHeader?.salesOrderHeader) {
                this.customerAccountNumber =
                  res.data.salesOrderHeader.salesOrderHeader.customerIdD365 ??
                  "";

                //this.getCustomerFinancialDimension(this.customerAccountNumber); //OptimizationWork: deferred to inline row edit

                this.patchValuesInSaleOrderHeader(
                  res.data.salesOrderHeader.salesOrderHeader
                );
                // this.patchValuesInInvoiceEmail(res.data.invoiceEmail || []);

                if (
                  res.data.salesOrderHeader.salesOrderHeader
                    .jniSalesInventoryD365
                ) {
                  this.orderType = "inventory-sales";
                  this.loadInventoryLookups();
                  //this.getAllVariants(); //OptimizationWork: deferred to inline row edit
                } else {
                  this.orderType = "all-sales";
                }

                if (
                  res?.data?.salesOrderHeader?.salesOrderHeader?.addressSelectionD365
                    ?.toLowerCase()
                    ?.includes("multi")
                ) {
                  this.patchValueInDeliveryName("Multiple Drop Ships");
                } else if (
                  res?.data?.salesOrderHeader?.salesOrderHeader?.addressSelectionD365
                    ?.toLowerCase()
                    ?.includes("tbd")
                ) {
                  this.patchValueInDeliveryName("TBD");
                } else {
                  this.patchValueInDeliveryName(
                    res.data.salesOrderHeader.salesOrderHeader
                      .deliveryNameD365 ?? ""
                  );
                }
                if (
                  res.data.salesOrderHeader?.salesOrderHeader?.customerIdD365
                ) {
                  // this.getAvailableCredit(
                  //   res.data.salesOrderHeader?.salesOrderHeader?.customerIdD365
                  // ); //OptimzationWork 27-02-2025
                  this.getCustomerDetail(
                    res.data.salesOrderHeader.salesOrderHeader.customerIdD365
                  );
                  // this.isCustomerPOFieldRequired(
                  //   res.data.salesOrderHeader?.salesOrderHeader?.customerIdD365
                  // ); //OptimzationWork 27-02-2025
                }

                this.getSellCurrencyConversion(
                  res.data.salesOrderHeader?.salesOrderHeader
                    ?.foreignCurrencyD365 ?? ""
                );
                this.getHeaderCalculation();
                if (
                  res.data.salesOrderHeader?.salesOrderHeader
                    ?.salesOrderStatusD365
                ) {
                  this.salesOrderStatusD365 =
                    res.data.salesOrderHeader.salesOrderHeader.salesOrderStatusD365;
                }
                if (
                  res.data.salesOrderHeader?.salesOrderHeader
                    ?.approvalStatusD365
                ) {
                  this.approvalStatusD365 =
                    res.data.salesOrderHeader.salesOrderHeader.approvalStatusD365;
                }
                this.checkOrderIsConfirmed();
                if (
                  res.data.salesOrderHeader?.salesOrderHeader
                    ?.methodOfPaymentD365
                ) {
                  this.applyFeeCardStatus =
                    res.data.salesOrderHeader.salesOrderHeader.methodOfPaymentD365;
                }

                if (res.data.salesOrderHeader?.salesOrderHeader?.shipDateD365) {
                  // const shipDate =
                  //   res.data?.salesOrderHeader?.salesOrderHeader?.shipDateD365;
                  // this.shipDate = shipDate;
                  const shipDate = new Date(
                    res.data?.salesOrderHeader?.salesOrderHeader?.shipDateD365
                  );
                  this.shipDate =
                    this.datepipe.transform(shipDate, "MM/dd/yyyy") ?? "";

                  this.saleOrderForm.patchValue({
                    orderHeader: {
                      shipDate: this.shipDate,
                    },
                  });
                }
                if (
                  res.data.salesOrderHeader?.salesOrderHeader?.inHandsDateD365
                ) {
                  // const inHandDate =
                  //   res.data.salesOrderHeader?.salesOrderHeader?.inHandsDateD365;
                  // this.inHandDate = inHandDate;
                  const inHandDate = new Date(
                    res.data.salesOrderHeader?.salesOrderHeader?.inHandsDateD365
                  );
                  this.inHandDate =
                    this.datepipe.transform(inHandDate, "MM/dd/yyyy") ?? "";
                  this.saleOrderForm.patchValue({
                    orderHeader: {
                      inHandsDate: inHandDate,
                    },
                  });
                }

                let candidate: Date | null = null;
                const shipOrgDate = toDateOrNull(
                  res.data?.salesOrderHeader?.salesOrderHeader?.shipDateD365
                );
                const inHandOrgDate = toDateOrNull(
                  res.data?.salesOrderHeader?.salesOrderHeader?.inHandsDateD365
                );
                if (shipOrgDate && inHandOrgDate) {
                  candidate =
                    new Date(
                      inHandOrgDate.getFullYear(),
                      inHandOrgDate.getMonth(),
                      inHandOrgDate.getDate()
                    ) <
                    new Date(
                      shipOrgDate.getFullYear(),
                      shipOrgDate.getMonth(),
                      shipOrgDate.getDate()
                    )
                      ? inHandOrgDate
                      : shipOrgDate;
                } else {
                  candidate = shipOrgDate ?? inHandOrgDate ?? null;
                }

                this.shipDateCurrentdate = computeMinDate(shipOrgDate);
                this.inHandDateCurrentdate = computeMinDate(candidate);

                if (!shipOrgDate && inHandOrgDate) {
                  this.shipDateCurrentdate = computeMinDate(inHandOrgDate);
                  this.inHandDateCurrentdate = computeMinDate(inHandOrgDate);
                } else if (shipOrgDate && !inHandOrgDate) {
                  this.shipDateCurrentdate = computeMinDate(shipOrgDate);
                  this.inHandDateCurrentdate = computeMinDate(
                    shipOrgDate,
                    false
                  );
                }

                if (
                  res.data.salesOrderHeader?.salesOrderHeader?.estimatedTaxD365
                ) {
                  this.estimatedTax =
                    res.data.salesOrderHeader?.salesOrderHeader?.estimatedTaxD365;
                  this.saleOrderForm.patchValue({
                    estimatedOrderTotals: {
                      estimatedTax: this.estimatedTax,
                    },
                  });
                }
                if (
                  res.data.salesOrderHeader?.salesOrderHeader
                    ?.recommendedTaxD365
                ) {
                  this.recommendedTax =
                    res.data.salesOrderHeader?.salesOrderHeader?.recommendedTaxD365;
                  this.saleOrderForm.patchValue({
                    estimatedOrderTotals: {
                      recommendedTax: this.recommendedTax,
                    },
                  });
                }
                if (
                  res.data.salesOrderHeader?.salesOrderHeader
                    ?.estimatedFreightD365
                ) {
                  this.estimatedFreight =
                    res.data.salesOrderHeader?.salesOrderHeader?.estimatedFreightD365;
                  this.saleOrderForm.patchValue({
                    estimatedOrderTotals: {
                      estimatedFreight: this.estimatedFreight,
                    },
                  });
                  this.calculateOrderTotal();
                }

                if (
                  res.data.salesOrderHeader?.salesOrderHeader.orderTotalD365
                ) {
                  this.orderTotalD365 =
                    res.data.salesOrderHeader?.salesOrderHeader?.orderTotalD365;
                }
              }

              if (
                res.data.salesOrderHeader?.address &&
                res.data.salesOrderHeader?.salesOrderHeader
                  ?.addressSelectionD365 &&
                !(
                  res.data.salesOrderHeader.salesOrderHeader.addressSelectionD365
                    .toLowerCase()
                    .includes("multi") ||
                  res.data.salesOrderHeader.salesOrderHeader.addressSelectionD365
                    .toLowerCase()
                    .includes("tbd")
                )
              ) {
                this.patchValuesInSaleOrderHeaderAddress(
                  res.data.salesOrderHeader?.address,
                  res.data.salesOrderHeader?.salesOrderHeader
                );
              } else {
                this.patchValueInAddressD365(
                  res.data.salesOrderHeader?.salesOrderHeader ??
                    ({} as SalesOrderHeader)
                );
              }

              this.patchValuesInAttentionLocation(
                res.data.salesOrderHeader?.salesOrderHeader
                  ?.attentionInformationD365 ?? "",
                res.data.salesOrderHeader?.salesOrderHeader?.locationD365 ?? "",
                res.data.salesOrderHeader?.salesOrderHeader
                  ?.rsmjniShipToEmail ?? ""
              );
              this.getProgramNameById(
                res?.data?.salesOrderHeader?.salesOrderHeader?.programId ?? 0
              );

              if (
                res.data.salesOrderHeader?.salesOrderHeader
                  ?.invoiceProposalExists
              ) {
                this.invoiceProposalExists =
                  res.data.salesOrderHeader?.salesOrderHeader
                    ?.invoiceProposalExists ?? "";
              }

              this.saleOrderData.salesOrderHeader = res?.data?.salesOrderHeader;
            } else {
              this._toastr.error("Error", res.message ?? "Data not found");
            }
          },
          error: res => {
            this._loaderService.setLoaderState(false);
            this._toastr.error("Error", res.message ?? "Data not found");
          },
        });
    }
  }

  getSalesOrderInvoiceEmails() {
    if (this.saleOrderId) {
      this._loaderService.setLoaderState(true);
      this._orderSummaryService
        .getSalesOrderInvoiceEmails(this.saleOrderId)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.data) {
              this.patchValuesInInvoiceEmail(res.data || []);
            }
          },
          error: res => {
            this._loaderService.setLoaderState(false);
            this._toastr.error("Error", res.message || "Data not found");
          },
        });
    }
  }

  patchValuesInAttentionLocation(
    attention: string,
    location: string,
    rsmjniShipToEmail: string
  ) {
    this.saleOrderForm.patchValue({
      shipTo: {
        locationD365: location,
        attentionInformationD365: attention,
        rSMJNIShipToEmailD365: rsmjniShipToEmail,
      },
    });
  }

  patchValueInDeliveryName(name: string) {
    this.saleOrderForm.patchValue({
      shipTo: {
        deliveryNameD365: name,
      },
    });
  }

  patchValueInAddressD365(salesOrderHeader: SalesOrderHeader) {
    let addressBook = "";
    if (
      salesOrderHeader?.addressSelectionD365
        ?.toLowerCase()
        .includes("address book")
    ) {
      addressBook = "Client Address Book";
    } else if (
      salesOrderHeader?.addressSelectionD365
        ?.toLowerCase()
        .toLowerCase()
        .includes("bill to")
    ) {
      addressBook = "Bill To";
    } else if (
      salesOrderHeader?.addressSelectionD365?.toLowerCase().includes("one time")
    ) {
      addressBook = "One Time";
    } else if (
      salesOrderHeader?.addressSelectionD365
        ?.toLowerCase()
        .includes("multi ship") ||
      salesOrderHeader?.addressSelectionD365?.toLowerCase().includes("multi") ||
      salesOrderHeader?.addressSelectionD365
        ?.toLowerCase()
        .includes("drop ship list")
    ) {
      addressBook = "Multi Ship To";
    } else if (
      salesOrderHeader?.addressSelectionD365?.toLowerCase()?.includes("tbd")
    ) {
      addressBook = "TBD";
    } else {
      addressBook = salesOrderHeader?.addressSelectionD365 ?? "";
    }
    this.saleOrderForm.patchValue({
      shipTo: {
        addressSelectionName: addressBook,
      },
    });
  }

  getSaleOrderLinesData() {
    if (this.saleOrderId) {
      this.smallLoader = true;
      this._orderSummaryService
        .getSaleOrderLinesData(this.saleOrderId)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.smallLoader = false;
            const odataFilter = `?$filter=ID eq '${this.saleOrderId}'`;
            this._orderSummaryService
              .GetJNIDeletedRecordsFilter(odataFilter)
              .subscribe();
            if (res.data) {
              if (res.data.length > 0) {
                if (res.data.length > 0) {
                  this.salesOrderLine = res.data;
                  this.salesOrderLineQuote = res.data.map(
                    this.mapSaleOrderLineToQuotesLine
                  );
                  //this.getPurchaseOrderLine(); // OptimzationWork 27-02-2025
                  if (!this.orderTotalD365) {
                    this.calculateSumOfSellTotalBeforeEdit(res?.data);
                  }
                  this.poExistFlag = this.isPOExist();
                  this.getHeaderCalculation();
                  this.calculateSubTotal();
                  this.calculateSumOfSellTotal();
                  this.isSaleOrderLinesConfirm();
                  this.checkLinesProposalIdField();
                  //this.getProjectId(); OptimzationWork 27-02-2025
                  this.IsSalesOrderInvoiced();
                  this.IsPartiallyInvoicedOrder();
                  this.setCategoryNameToLines();
                  this.IsSalesOrderDeliveredWithInvoicedAndDeliveredLines();

                  const flagForPos = this.salesOrderLine.findIndex(
                    x => x.salesOrderLine?.purchaseOrderD365
                  );
                  if (flagForPos !== -1) {
                    this.openPrinfPdfFlag = true;
                  }
                }
              }
              this.hideButtonsOnPageLoad = false;
              this.isEditButtonVisible = true;
              this.saleOrderData.salesOrderLine = res?.data;
              this.populateMenuItem();
            } else {
              this.smallLoader = false;
              this._toastr.error("Error", res.message || "Data not found");
            }
            if (this.saleOrderModalStatus) {
              this._loaderService.setLoaderState(false);
            } else {
              this._loaderService.setLoaderState(false);
            }

            this.showCopyButton = true;
          },
          error: res => {
            this._loaderService.setLoaderState(false);
            this.smallLoader = false;
            this._toastr.error("Error", res.message || "Data not found");
          },
        });
    }
  }

  getProjectId() {
    const line = this.salesOrderLine.find(x => x.salesOrderLine?.projectIdD365);

    if (line?.salesOrderLine?.projectIdD365) {
      this.projId = line.salesOrderLine.projectIdD365;
      this.getOrderTrackingData();
    }
  }

  isSaleOrderLinesConfirm() {
    if (this.salesOrderLine.length > 0) {
      const index = this.salesOrderLine.find(
        x => x.salesOrderLine?.lineRecIdD365 !== null
      );

      if (index) {
        this.isSaleOrderLineSync = this.salesOrderLine.filter(
          x => x.salesOrderLine?.status === 1 && x.salesOrderLine?.isActive
        );
      } else {
        this.isSaleOrderLineSync = this.salesOrderLine.filter(
          (a: SaleOrderLineAddressDto) =>
            (a.salesOrderLine?.status == 1 || a.salesOrderLine?.status == 2) &&
            a.salesOrderLine?.isActive
        );
      }

      if (this.isSaleOrderLineSync.length) {
        this.isSaleOrderLineConfirmStatus = true;
      } else {
        this.isSaleOrderLineConfirmStatus = false;
      }
    }
  }

  isPOExist() {
    for (const x of this.salesOrderLine) {
      if (x.salesOrderLine?.purchaseOrderD365) {
        return true;
      }
    }
    return false;
  }

  isCustomerPOFieldRequired(accountNumber: string) {
    this._clientDetailsService
      .IsCustomerPOFieldRequired(accountNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data) {
            this.setCustomerPoRequiredField();
          } else {
            this.removeCustomerPoRequiredField();
          }
        },
        error: res => {
          this._toastr.error(res.message, "Error");
        },
      });
  }

  setCustomerPoRequiredField() {
    this.isCustomerPoRequiredField = true;
    this.saleOrderForm
      .get(["orderDetails", "customerPONumber"])
      ?.setValidators(Validators.required);
    this.saleOrderForm
      .get(["orderDetails", "customerPONumber"])
      ?.updateValueAndValidity();
  }

  removeCustomerPoRequiredField() {
    this.isCustomerPoRequiredField = false;
    this.saleOrderForm
      .get(["orderDetails", "customerPONumber"])
      ?.clearValidators();
    this.saleOrderForm
      .get(["orderDetails", "customerPONumber"])
      ?.updateValueAndValidity();
  }

  getHeaderCalculation() {
    setTimeout(() => {
      if (
        this.foreignCurrency &&
        this.foreignCurrency.toLowerCase() !== "usd"
      ) {
        // this.calculateNetAfterCurrencyConvert();
        this.calculateNet();
        this.calculateNetGpAfterCurrencyConvert();
        this.calculateSubtotalCreditForNonUS();
      } else {
        this.calculateNet();
        this.calculateNetGp();
        this.calculateSubtotalCreditForUS();
      }
    }, 0);
  }

  subtotalForCreditLimitCheck = 0;

  calculateSubtotalCreditForUS() {
    const sellTotal = this.salesOrderLine.reduce(
      (prev: number, next: SaleOrderLineAddressDto) => {
        return (
          prev +
          (next?.salesOrderLine?.sellTotalD365
            ? parseFloat(next?.salesOrderLine?.sellTotalD365)
            : 0)
        );
      },
      0
    );
    this.subtotalForCreditLimitCheck = sellTotal;
  }

  calculateSubtotalCreditForNonUS() {
    const sellTotal = this.salesOrderLine.reduce(
      (prev: number, next: SaleOrderLineAddressDto) => {
        return (
          prev +
          (next.salesOrderLine?.sellConversionTotal === null ||
          next.salesOrderLine?.sellConversionTotal === ""
            ? 0
            : parseFloat(next.salesOrderLine?.sellConversionTotal ?? ""))
        );
      },
      0
    );
    this.subtotalForCreditLimitCheck = sellTotal;
  }

  getOneTimeAddress() {
    const deliveryAddress = this.saleOrderForm.get([
      "shipTo",
      "addressSelectionName",
    ])?.value as string;

    if (deliveryAddress.toLowerCase().includes("one")) {
      this.showAddress = false;
      return true;
    } else {
      this.saleOrderForm.get(["shipTo", "addressD365"])?.disable();
      this.showAddress = true;
      return false;
    }
  }

  getSellCurrencyConversion(currency: string) {
    this.foreignCurrency = currency;
    this.showSmallLoader = true;
    if (currency && currency.toLowerCase() != "usd") {
      const filter = {
        and: [
          {
            RateTypeName: "Closing",
          },
          {
            FromCurrency: currency,
          },
          {
            ToCurrency: "USD",
          },
        ],
      };
      const query = buildQuery({ filter });
      this._samplepoListingService
        .getCurrencyConversion(query)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.showSmallLoader = false;
            const sortedCurrency = res.data.sort((a, b) => {
              if (a.EndDate > b.EndDate) {
                return -1;
              }
              if (a.EndDate < b.EndDate) {
                return 1;
              }
              return 0;
            });
            this.currencyConversion = sortedCurrency[0];
            this.sellCurrencyRate = this.currencyConversion.Rate || 1;
            this.getHeaderCalculation();
          },
          error: () => {
            this.showSmallLoader = false;
          },
        });
    }
  }

  getCustomerDetail(customerAccountNumber: string) {
    this._customerAccountService
      .getCustomerByNameAndAccountNumberFilter(
        customerAccountNumber,
        EnumModuleType[EnumModuleType.Orders],
        this.saleOrderId
      )
      .subscribe({
        next: res => {
          if (res.data) {
            this.customerBillToObject = res.data[0];
            this.patchValueInCustomerDetail(res.data[0]);
            this.patchValueInCustomerAddressField(
              res?.data[0]?.partyNumber ?? "",
              customerAccountNumber
            );

            this.partyNumber = res?.data[0]?.partyNumber ?? "";
            // this.getAllContactsByAccountNumber(
            //   customerAccountNumber,
            //   res?.data[0]?.partyNumber
            // ); //OptimzationWork 27-02-2025
            const bcPersonnelNumber = this.saleOrderForm.get([
              "orderHeader",
              "brandingConsultant",
            ])?.value;
            this.getBCForSalesOrder(
              this.customerBillToObject?.clientAccount,
              bcPersonnelNumber,
              ""
            );

            if (this.customerBillToObject?.name) {
              this.shipTo.billToAddressField =
                this.customerBillToObject.name || "";
            }
          }
        },
      });
  }

  getAvailableCredit(accountNumber: string) {
    this._clientDetailsService
      .getAvailableCredit(accountNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.getAvailableCreditBtnStatus = true;
          if (res?.status?.toLowerCase() != "success") {
            this.avaiableCredit = 0;
            this._toastr.error(res?.message, "Error");
          } else {
            this.avaiableCredit = res?.data?.availableCredit;
          }
        },
        error: res => {
          this.getAvailableCreditBtnStatus = true;
          this.avaiableCredit = 0;
          this._toastr.error(res?.message, "Error");
        },
      });
  }

  getBCForSalesOrder(
    accountNumber: string,
    bcPersonnelNumber: string,
    status: string
  ) {
    this._saleOrderService
      .getBCForSalesOrder(accountNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: async res => {
          if (res.data != null) {
            this.brandingConsultantLists =
              await this.checkIfBcExistsInSalesOrder(
                res.data,
                bcPersonnelNumber
              );

            const filterBcObject = this.brandingConsultantLists.filter(
              x => x.personnelNumber === bcPersonnelNumber
            );

            if (filterBcObject.length > 0) {
              this.bcProjectId = filterBcObject[0].personnelNumber;
              this.patchValueInBrandingConsultant(
                filterBcObject[0].projectName
              );
            } else {
              //
              this.patchValueInBrandingConsultant("");
            }
            if (status === "edit") {
              this.getBacForSaleOrderEdit(filterBcObject[0]?.personnelNumber);
            } else {
              this.getBacForSalesOrder(filterBcObject[0]?.personnelNumber);
            }
          }
        },
      });
  }

  async checkIfBcExistsInSalesOrder(
    data: GetBCForSalesOrderDto[],
    bcPersonnelNumber: string
  ) {
    const filterBcObject = data.filter(
      x => x.personnelNumber === bcPersonnelNumber
    );

    if (filterBcObject.length > 0) {
      return data;
    } else {
      const res = await lastValueFrom(
        this._orderSummaryService.getEmployeeByPersonnelNumber(
          bcPersonnelNumber
        )
      );

      if (res.status.toLowerCase() == "success") {
        data.push({
          partyNumber: "",
          personnelNumber: res.data.personnelNumber ?? "",
          projectId: res.data.projectId ?? "",
          projectName: `${res.data.firstName} ${res.data.lastName}`,
          isPrimary: false, //Not required in this case thats why make if false
        });
      }

      return data;
    }
  }

  getBacForSalesOrder(personnelNumber: string) {
    this._saleOrderService
      .getBacForSalesOrder(personnelNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data != null) {
            this.bacList = res.data;
            const findBac = res.data.find(
              x =>
                x.personnelNumber ===
                this.salesOrderHeaderData.salesOrderHeader
                  ?.accountsCoordinatorD365
            );
            if (!findBac) {
              this.showBacUserInputField = true;
              this.getRemovedBacForSalesOrder(
                this.salesOrderHeaderData.salesOrderHeader
                  ?.accountsCoordinatorD365 ?? ""
              );
            } else {
              this.showBacUserInputField = false;
            }
          }
        },
      });
  }

  getBacForSaleOrderEdit(personnelNumber: string) {
    this._saleOrderService
      .getBacForSalesOrder(personnelNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: GenericResponseDto<GetBacForSalesOrderDto[]>) => {
          if (res.data != null) {
            this.bacList = res.data;
            const filterBacObject = res.data.filter(
              x => x.personnelNumber === this.userPersonnelNumber
            );
            if (filterBacObject.length > 0) {
              this.bacUserDefaultSelectionId =
                filterBacObject[0].personnelNumber;
            } else {
              if (this.bacList.length > 0) {
                this.bacUserDefaultSelectionId =
                  this.bacList[0].personnelNumber;
                this.patchValueInBacField(this.bacUserDefaultSelectionId);
              } else {
                this.bacUserDefaultSelectionId = "";
              }
            }
          }
        },
      });
  }

  patchValueInBacField(personnelNumber: string) {
    this.saleOrderForm.patchValue({
      orderHeader: {
        accountsCoordinator: personnelNumber,
      },
    });
  }

  patchValueInCustomerDetail(customerObject: ClientSearchList) {
    if (customerObject) {
      this.saleOrderForm.patchValue({
        customerAddress: {
          name: customerObject?.organizationNameD365,
          telephone: customerObject?.locator,
          // billingAttentionD365: customerObject?.billingAttentionD365,
          // billingLocationD365: customerObject?.billingLocationD365
        },
      });
    }
  }

  patchValueInBrandingConsultant(data: string) {
    this.saleOrderForm.patchValue({
      orderHeader: {
        brandingConsultant: data,
      },
    });
  }

  patchValueInCustomerAddressField(partyNumber: string, accountNumber: string) {
    this._customerAccountService
      .getCustomerAddressByPartyNumber(partyNumber, accountNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.shiftToAddressList = res.data;
          if (this.shiftToAddressList.length > 0 && this.headerAddress) {
            const address = this.shiftToAddressList?.filter(
              (x: Address) =>
                x.addressD365 === this.headerAddress?.addressD365 &&
                x.locationNumberD365?.toString() ===
                  this.headerAddress?.locationNumberD365?.toString()
            );
            if (address?.length > 0) {
              this.shipTo.shiftToAddressField =
                address[0]?.descriptionD365 ?? "";
            }
          }

          const primaryAddress = res.data.filter(
            (x: Address) =>
              x.isPrimaryD365?.toLowerCase() === "yes" ||
              x.isPrimaryD365?.toLowerCase() === "1"
          );
          if (primaryAddress.length > 0) {
            if (primaryAddress[0].addressD365) {
              this.patchValuesInCustomerFormAddressField(
                primaryAddress[0].addressD365
              );
            }
          }
        },
      });
  }

  patchValuesInCustomerFormAddressField(address: string) {
    this.saleOrderForm.patchValue({
      customerAddress: {
        address: address,
      },
    });
  }

  calculateNet() {
    if (this.salesOrderLine.length > 0) {
      const total = this.salesOrderLine.reduce(
        (prev: number, next: SaleOrderLineAddressDto) => {
          return (
            prev +
            (next?.salesOrderLine?.isnetInForeignCurrencyStatus
              ? parseFloat(
                  next.salesOrderLine?.netConversionTotalD365?.toString() ?? "0"
                )
              : parseFloat(
                  next.salesOrderLine?.netTotalD365?.toString() ?? "0"
                ))
          );
        },
        0
      );
      this.net = total.toString();
    }
  }

  calculateNetGp() {
    if (this.salesOrderLine.length > 0) {
      const sellTotal = this.salesOrderLine.reduce(
        (prev: number, next: SaleOrderLineAddressDto) => {
          return (
            prev +
            (next.salesOrderLine?.sellTotalD365
              ? parseFloat(next.salesOrderLine?.sellTotalD365)
              : 0)
          );
        },
        0
      );

      const serviceFee = this.serviceFeeFromD365 * sellTotal;

      const distinctCurrencyCodeList: string[] = [];
      this.salesOrderLine.reduce((acc, curr) => {
        const key = curr.salesOrderLine?.currencyCodeD365 ?? "";
        if (!distinctCurrencyCodeList.includes(key) && key && key !== "USD") {
          distinctCurrencyCodeList.push(key);
        }
        return distinctCurrencyCodeList;
      }, {});

      const netTotalUsd = this.salesOrderLine
        .filter(
          item => item.salesOrderLine?.isnetInForeignCurrencyStatus !== true
        )
        .reduce(
          (sum, current) => sum + (current?.salesOrderLine?.netTotalD365 ?? 0),
          0
        );
      let netNotInUsdSubTotal = 0;
      if (distinctCurrencyCodeList?.length > 0) {
        distinctCurrencyCodeList?.forEach(async (element: string) => {
          const netTotalNotUsd = this.salesOrderLine
            .filter(
              item =>
                item?.salesOrderLine?.isnetInForeignCurrencyStatus === true &&
                element === item?.salesOrderLine?.currencyCodeD365
            )
            .reduce(
              (sum, current) =>
                sum + (current?.salesOrderLine?.netTotalD365 ?? 0),
              0
            );

          const filter = {
            and: [
              {
                RateTypeName: "Closing",
              },
              {
                FromCurrency: element,
              },
              {
                ToCurrency: "USD",
              },
            ],
          };
          const query = buildQuery({ filter });
          const conversionRate =
            await this._samplepoListingService.getCurrencyConversionC(query);
          netNotInUsdSubTotal =
            netNotInUsdSubTotal + netTotalNotUsd * conversionRate;
          const netTotal = netTotalUsd + netNotInUsdSubTotal;
          this.netGp = sellTotal - netTotal - serviceFee;

          this.calculateNetProfitPercentage(this.netGp, sellTotal);
          this.calculateCommission(this.netGp);
        });
      } else {
        const netTotal = netTotalUsd + netNotInUsdSubTotal;
        this.netGp = sellTotal - netTotal - serviceFee;

        this.calculateNetProfitPercentage(this.netGp, sellTotal);
        this.calculateCommission(this.netGp);
      }
    }
  }

  calculateCommission(gp: number) {
    if (this.salesOrderLine.length > 0) {
      this.commission = gp * 0.5;
    }
  }

  async calculateNetGpAfterCurrencyConvert() {
    if (this.salesOrderLine.length > 0) {
      const sellTotal = this.salesOrderLine.reduce(
        (prev: number, next: SaleOrderLineAddressDto) => {
          return (
            prev +
            (next.salesOrderLine?.sellTotalD365
              ? parseFloat(next.salesOrderLine?.sellTotalD365)
              : 0)
          );
        },
        0
      );

      let sellTotalInUsd = 0;

      if (
        this.salesOrderHeaderData.salesOrderHeader?.foreignCurrencyD365 &&
        this.salesOrderHeaderData.salesOrderHeader?.foreignCurrencyD365?.toLowerCase() !==
          "usd"
      ) {
        const filter = {
          and: [
            {
              RateTypeName: "Closing",
            },
            {
              FromCurrency:
                this.salesOrderHeaderData.salesOrderHeader?.foreignCurrencyD365,
            },
            {
              ToCurrency: "USD",
            },
          ],
        };
        const query = buildQuery({ filter });
        const conversionRateHeader =
          await this._samplepoListingService.getCurrencyConversionC(query);

        sellTotalInUsd = sellTotal * conversionRateHeader;
      } else {
        sellTotalInUsd = sellTotal;
      }

      const serviceFee = this.serviceFeeFromD365 * sellTotalInUsd;

      const distinctCurrencyCodeList: string[] = [];
      this.salesOrderLine.reduce((acc, curr: SaleOrderLineAddressDto) => {
        const key = curr.salesOrderLine?.currencyCodeD365 ?? "";
        if (!distinctCurrencyCodeList.includes(key) && key !== "USD") {
          distinctCurrencyCodeList.push(key);
        }
        return distinctCurrencyCodeList;
      }, {});

      const netTotalUsd = this.salesOrderLine
        .filter(
          item => item.salesOrderLine?.isnetInForeignCurrencyStatus !== true
        )
        .reduce(
          (sum, current) => sum + (current?.salesOrderLine?.netTotalD365 ?? 0),
          0
        );
      let netNotInUsdSubTotal = 0;
      if (distinctCurrencyCodeList?.length > 0) {
        distinctCurrencyCodeList?.forEach(async (element: string) => {
          const netTotalNotUsd = this.salesOrderLine
            .filter(
              item =>
                item?.salesOrderLine?.isnetInForeignCurrencyStatus === true &&
                element === item?.salesOrderLine?.currencyCodeD365
            )
            .reduce(
              (sum, current) =>
                sum + (current?.salesOrderLine?.netTotalD365 ?? 0),
              0
            );

          const filter = {
            and: [
              {
                RateTypeName: "Closing",
              },
              {
                FromCurrency: element,
              },
              {
                ToCurrency: "USD",
              },
            ],
          };
          const query = buildQuery({ filter });
          const conversionRate =
            await this._samplepoListingService.getCurrencyConversionC(query);
          netNotInUsdSubTotal =
            netNotInUsdSubTotal + netTotalNotUsd * conversionRate;
          const netTotal = netTotalUsd + netNotInUsdSubTotal;
          this.netGp = sellTotalInUsd - netTotal - serviceFee;

          this.calculateNetProfitPercentageAfterConvert(
            this.netGp,
            sellTotalInUsd
          );
          this.calculateCommissionAfterConvert(this.netGp);
        });
      } else {
        const netTotal = netTotalUsd + netNotInUsdSubTotal;
        this.netGp = sellTotalInUsd - netTotal - serviceFee;

        this.calculateNetProfitPercentageAfterConvert(
          this.netGp,
          sellTotalInUsd
        );
        this.calculateCommissionAfterConvert(this.netGp);
      }
    }
  }

  calculateCommissionAfterConvert(gp: number) {
    if (this.salesOrderLine.length > 0) {
      this.commission = gp * 0.5;
    }
  }

  calculateNetProfitPercentageAfterConvert(gp: number, sellTotal: number) {
    if (this.salesOrderLine.length > 0) {
      const gpPercentage = (gp / Math.abs(sellTotal)) * 100;
      this.netGpPercentage = gpPercentage;
    }
  }

  getInfinity(percentage: number) {
    if (Number.isFinite(percentage)) {
      return true;
    } else {
      return false;
    }
  }

  calculateSubTotal() {
    if (this.salesOrderLine.length > 0) {
      const total = this.salesOrderLine
        .filter(
          x => x.salesOrderLine && x.salesOrderLine.lineStatusD365 != "Canceled"
        )
        .reduce((prev: number, next: SaleOrderLineAddressDto) => {
          return (
            prev +
            (next.salesOrderLine?.sellTotalD365
              ? parseFloat(next.salesOrderLine?.sellTotalD365 ?? "0")
              : 0)
          );
        }, 0);
      this.subTotal = total.toString();
      this.calculateOrderTotal();
    }
  }

  calculateOrderTotal() {
    const total =
      parseFloat(this.subTotal) + this.estimatedTax + this.estimatedFreight;
    this.orderTotal = total;
  }

  sumOfSellTotal = 0;
  calculateSumOfSellTotal() {
    if (this.salesOrderLine.length > 0) {
      const sumOfSellTotal = this.salesOrderLine.reduce(
        (prev: number, next: SaleOrderLineAddressDto) => {
          return (
            prev +
            (next.salesOrderLine?.sellD365
              ? parseFloat(next.salesOrderLine?.sellD365.toString() ?? "0")
              : 0)
          );
        },
        0
      );
      this.sumOfSellTotal = sumOfSellTotal;
    }
  }

  calculateSumOfSellTotalBeforeEdit(saleorderline: SaleOrderLineAddressDto[]) {
    if (saleorderline.length > 0) {
      const sumOfSellTotal = saleorderline.reduce(
        (prev: number, next: SaleOrderLineAddressDto) => {
          return (
            prev +
            (next.salesOrderLine?.sellTotalD365
              ? parseFloat(next.salesOrderLine?.sellTotalD365)
              : 0)
          );
        },
        0
      );
      this.orderTotal = sumOfSellTotal;
      this.patchValueInOrderTotal(this.orderTotal);
    }
  }

  calculateNetProfitPercentage(gp: number, sellTotal: number) {
    if (this.salesOrderLine.length > 0) {
      const gpPercentage = (gp / Math.abs(sellTotal)) * 100;
      this.netGpPercentage = gpPercentage;
    }
  }

  refreshPage(event: boolean) {
    if (event) {
      this.getSaleOrderHeaderData(false);
      this.getSaleOrderLinesData();
      //this.ngOnInit();
    }
  }

  refreshSalesOrderLines() {
    this.getSaleOrderLinesData();
  }

  setAllCollapseAll() {
    this.collapseHeaderStatus = false;
    this.expandHeaderStatus = true;
    this.collapseHeaderHeading = "Collapse Header";

    this.collapseNotesStatus = true;
    this.expandNotesStatus = false;
    this.collapseNotesHeading = "Collapse all";
  }

  onHeaderToggle() {
    if (this.expandHeaderStatus) {
      this.collapseHeaderStatus = true;
      this.expandHeaderStatus = false;
      this.setStateOfExpandAll();
      this.collapseHeaderHeading = "Expand Header";
    } else {
      this.collapseHeaderStatus = false;
      this.expandHeaderStatus = true;
      this.setStateOfCollapseAll();
      this.collapseHeaderHeading = "Collapse Header";
    }
  }

  onNotesToggle() {
    if (this.expandNotesStatus) {
      this.collapseNotesStatus = true;
      this.expandNotesStatus = false;
      this.setNotesStateOfExpandAll();
      this.collapseNotesHeading = "Collapse all";
    } else {
      this.collapseNotesStatus = false;
      this.expandNotesStatus = true;
      this.setNotesStateOfCollapseAll();
      this.collapseNotesHeading = "Expand all";
    }
  }

  setStateOfExpandAll() {
    localStorage.setItem("sale-order-collapse", "true");
  }

  setStateOfCollapseAll() {
    localStorage.setItem("sale-order-collapse", "false");
  }

  setNotesStateOfExpandAll() {
    localStorage.setItem("sale-order-Notes-collapse", "true");
  }

  setNotesStateOfCollapseAll() {
    localStorage.setItem("sale-order-Notes-collapse", "false");
  }

  getStateOfCollapseAll() {
    const status = localStorage.getItem("sale-order-collapse");
    if (status) {
      if (status === "true") {
        this.collapseHeaderStatus = true;
        this.expandHeaderStatus = false;
        this.collapseHeaderHeading = "Expand Header";
      } else {
        this.collapseHeaderStatus = false;
        this.expandHeaderStatus = true;
        this.collapseHeaderHeading = "Collapse Header";
      }
    }
  }

  // getNotesStateOfCollapseAll() {
  //   const status = localStorage.getItem('sale-order-Notes-collapse');
  //   if (status) {
  //     if (status === 'true') {
  //       this.collapseNotesStatus = true;
  //       this.expandNotesStatus = false;
  //       this.collapseNotesHeading = 'Collapse all';
  //     } else {
  //       this.collapseNotesStatus = false;
  //       this.expandNotesStatus = true;
  //       this.collapseNotesHeading = 'Expand all';
  //     }
  //   }
  // }

  onSaleOrderEdit() {
    if (this.showBacUserInputField === true) {
      this.showBacUserInputField = false;
      this.bacUserDefaultSelectionId = "";
      this.saleOrderForm.patchValue({
        orderHeader: {
          accountsCoordinator: "",
        },
      });

      this.saleOrderForm.get(["orderHeader", "accountsCoordinator"])?.enable();

      const accountsCoordinatorControl = this.saleOrderForm.get([
        "orderHeader",
        "accountsCoordinator",
      ]);
      accountsCoordinatorControl?.markAsTouched();
      accountsCoordinatorControl?.markAsDirty();
      this.logValidationErrors();
    }

    this.ApiCallsOnSalesOrderEdit();

    this.editStatus = "Edit";
    this.backgroundColor = "#FFFFFF";
    if (this.salesOrderStatusD365.toLowerCase() === "invoiced") {
      this._toastr.error("Error", "Cannot update an invoiced sales order");
      return;
    }
    if (!this.userBlockedFromEdit) {
      this._toastr.error(
        "Error",
        "Sales Order Commission BC not found in Client Primary BC"
      );
      return;
    }

    this.setAllCollapseAll();

    /* If proposalIdD365 is salesOrderLines found empty in any array index then editable fields
     Only are Clinet PO and Job name as per the ticket 11204 */
    if (this.proposalIdD365EditFieldValidation) {
      this.saleOrderForm.get(["orderDetails", "customerPONumber"])?.enable();
      this.saleOrderForm.get(["orderHeader", "jobName"])?.enable();
      this.saleOrderForm.get(["orderDetails", "shippingMethod"])?.enable();
      this.updateButtonValidation = false;
      this.editHeaderStatus = true;
      return;
    }

    this.shipTo.salesOrderEditCase = true;
    this.editHeaderStatus = true;
    this.backgroundColor = "#FFFFFF";

    // Disable all times now as per the ticket 12194
    // this.saleOrderForm.get(['orderHeader', 'customerId'])?.enable();

    this.saleOrderForm.get(["orderHeader", "buyer"])?.enable();
    this.saleOrderForm.get(["orderHeader", "jobName"])?.enable();
    this.saleOrderForm.get(["orderHeader", "shipDate"])?.enable();
    this.saleOrderForm.get(["orderHeader", "inHandsDate"])?.enable();
    this.saleOrderForm.get(["orderHeader", "methodOfPaymentHeader"])?.enable();
    this.saleOrderForm.get(["orderHeader", "programId"])?.enable();

    this.saleOrderForm.get(["shipTo", "addressSelectionName"])?.enable();
    this.saleOrderForm.get(["shipTo", "attentionInformationD365"])?.enable();
    this.saleOrderForm.get(["shipTo", "streetD365"])?.enable();
    this.saleOrderForm.get(["shipTo", "locationD365"])?.enable();
    this.saleOrderForm.get(["shipTo", "countryRegionIdD365"])?.enable();
    this.saleOrderForm.get(["shipTo", "zipCodeD365"])?.enable();
    this.saleOrderForm.get(["shipTo", "addressD365"])?.enable();
    this.saleOrderForm.get(["shipTo", "addressFormat"])?.enable();
    this.saleOrderForm.get(["shipTo", "buildingComplimentD365"])?.enable();
    this.saleOrderForm.get(["shipTo", "rSMJNIShipToEmailD365"])?.enable();
    this.saleOrderForm.get(["shipTo", "deliveryNameD365"])?.enable();

    // this.saleOrderForm.get(['orderDetails', 'buyer'])?.enable();
    this.saleOrderForm.get(["orderDetails", "customerPONumber"])?.enable();
    this.saleOrderForm.get(["orderDetails", "shippingMethod"])?.enable();
    this.saleOrderForm.get(["orderDetails", "creditCardFeeCharge"])?.enable();
    if (this.orderType === "inventory-sales") {
      this.saleOrderForm.get(["orderDetails", "store"])?.enable();
      this.saleOrderForm.get(["orderDetails", "warehouse"])?.enable();
      const store = this.saleOrderForm.get(["orderDetails", "store"])?.value;
      const warehouse = this.saleOrderForm.get([
        "orderDetails",
        "warehouse",
      ])?.value;
      this.refreshOwners(store, warehouse);
    }
    this.hiddenShipDate = false;
    this.hiddenInHandDate = false;
    this.updateButtonValidation = false;
    this.estimatedTaxStatus = false;
    this.estimatedFreightStatus = false;
    this.saleOrderForm.get(["orderHeader", "brandingConsultant"])?.enable();
    this.saleOrderForm.get(["orderHeader", "accountsCoordinator"])?.enable();
    this.shipTo.onDeliveryAddressChange(
      this.saleOrderForm.get(["shipTo", "addressSelectionName"])?.value,
      false
    );

    this.programs.disableEnableProgram(false);

    const custId = (this.customerId = this.saleOrderForm.get([
      "orderHeader",
      "customerId",
    ])?.value);
    this.programs.getAllProgramDetailsByCustomerAccount(custId, false);

    this.saleOrderForm.get(["shipTo", "streetD365"])?.clearValidators();
    this.saleOrderForm.get(["shipTo", "streetD365"])?.updateValueAndValidity();

    // ToDO the code if address lines needed to show
    // const countryRegion = (this.customerId = this.saleOrderForm.get([
    //   "shipTo",
    //   "countryRegionIdD365",
    // ])?.value);

    //  if(countryRegion !== 'USA'){
    //    this.shipTo.onCountryRegionSelection(countryRegion ?? '') ;
    //    this.shipTo.showAddressLinesFields = false; // To Show Address Lines1,2,3
    // }
  }

  onShipDateSelection(event: Date) {
    //const shipDate = event;
    const shipDate = new Date(event);
    this.sharedMonthForView = shipDate;
    this.shipDate = this.datepipe.transform(shipDate, "MM/dd/yyyy") ?? "";
    if (this.shipDate) {
      this.inHandDateCurrentdate = computeMinDate(this.shipDate, false);
    } else {
      this.inHandDateCurrentdate = computeMinDate();
    }
    this.saleOrderForm.patchValue({
      orderHeader: {
        shipDate: this.shipDate,
      },
    });
  }

  onInHandDateSelection(event: Date) {
    // const inHandDate = event;
    const inHandDate = new Date(event);
    this.inHandDate = this.datepipe.transform(inHandDate, "MM/dd/yyyy") ?? "";
    this.saleOrderForm.patchValue({
      orderHeader: {
        inHandsDate: this.inHandDate,
      },
    });
  }

  onShippingMethodChange(
    event: SelectChangeEvent | string,
    changeAccount = true
  ) {
    const target = typeof event === "string" ? event : event.value;
    const index = this.shippingProductsList.findIndex(
      x => x.modeCodeD365 == target
    );

    if (index > -1) {
      this.patchValueInShippingMethod(
        this.shippingProductsList[index].modeDescriptionD365
      );
      const selectedShippingMethod = this.shippingProductsList[index];
      if (
        selectedShippingMethod.useFreightAccountD365?.toLowerCase() == "yes" &&
        changeAccount === true
      ) {
        this.patchValueInAccount(selectedShippingMethod.jniFreightAcctNumD365);
      } else if (changeAccount === true) {
        this.patchValueInAccount("");
      }
    } else {
      this.patchValueInShippingMethod("");
    }
  }

  patchValueInShippingMethod(descriptionName: string) {
    this.saleOrderForm.patchValue({
      orderDetails: {
        shippingMethodName: descriptionName,
      },
    });
  }

  getMehtodPaymentListData() {
    const params = "?";
    this._saleOrderService
      .getMethodPaymentList(params)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.customerPaymentMethodList = res.data;
        },
      });
  }

  getAllReleaseProduct() {
    this._orderSummaryService
      .getAllCategory()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.releasedProductsList =
            this.orderType == "inventory-sales"
              ? res.data.filter(item => item.soStopped === "No")
              : res.data.filter(
                  x => x.itemNumberD365 != "Misc" && x.soStopped === "No"
                );
        },
      });
  }

  getAllShippingMethod() {
    this._samplepoListingService
      .getAllShippingMethod()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          const shippingData = res.data;
          this.shippingProductsList = shippingData.filter(
            x => x.jniUseOnSalesOrderD365 !== "No"
          );
          this.onShippingMethodChange(this.shippingMethodD365, false);
        },
      });
  }

  getCreditCard(event: SelectChangeEvent) {
    let value = "";
    if (typeof event === "string") {
      value = event;
    } else {
      value = event?.value;
    }

    if (value === "CC") {
      this.applyCreditCardStatus = false;
    } else {
      this.applyCreditCardStatus = true;
    }
  }

  // onCustomerSearchOpenToggle(mydrop: any, event: any) {
  //   const custCheckVal = this.saleOrderForm.get([
  //     'orderHeader',
  //     'customerId'
  //   ])?.value;
  //   if (this.editStatus != 'Edit' && custCheckVal) {
  //     event.preventDefault();
  //     this.backgroundColor = '#FAFAFA';
  //   } else {
  //     mydrop.open();
  //     this.backgroundColor = '#FFFFFF';
  //   }
  // }

  // onCustomerKeyDown(mydrop: any, event: any) {
  //   const custCheckVal = this.saleOrderForm.get([
  //     'orderHeader',
  //     'customerId'
  //   ])?.value;
  //   if (this.editStatus != 'Edit' && custCheckVal) {
  //     event.preventDefault();
  //     this.backgroundColor = '#FAFAFA';
  //   } else {
  //     mydrop.open();
  //     this.backgroundColor = '#FFFFFF';
  //   }
  // }

  onKeyDown(event: KeyboardEvent) {
    event.preventDefault();
  }

  // getCustomerAccount(event: any, mydrop: any) {
  //   this.showSmallLoader = true;
  //   if (event.which == 9) {
  //     const countryValue = event.target.value;
  //     this._customerAccountService
  //       .getCustomerByNameAndAccountNumberFilter(countryValue)
  //       .pipe(untilDestroyed(this))
  //       .subscribe({
  //         next: (res: GenericResponseDto<ClientSearchList[]>) => {
  //           this.customerLists = res.data;
  //           if (this.customerLists.length > 0) {
  //             this.onClientSelection(this.customerLists[0], mydrop);
  //             this.clearShipToEvent.emit();
  //           }
  //           this.showSmallLoader = false;
  //         },
  //         error: () => {
  //           this.showSmallLoader = false;
  //         }
  //       });
  //   }
  // }

  searchCustomerName() {
    this.customerVendor$
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        switchMap((searchitem: string) => {
          const accountNumberOrName = searchitem;
          this.customerLists = [];
          if (accountNumberOrName != "" && accountNumberOrName != undefined) {
            return this._customerAccountService.getCustomerByNameAndAccountNumberFilter(
              accountNumberOrName
            );
          }
          return EMPTY;
        })
      )
      .subscribe({
        next: res => {
          if (res.data != null) {
            this.customerLists = res.data;
          }
        },
      });
  }

  // onClientSelection(event: any, clientProspetToggle: any) {
  //   this.selectedAccountNumber = event.clientAccount;
  //   // To Do
  //   //this.programs.getAllProgramDetailsByCustomerAccount(this.selectedAccountNumber, false);
  //   this.saleOrderForm.patchValue({
  //     orderHeader: {
  //       customerId: event.clientAccount
  //     },
  //     customerAddress: {
  //       name: event.organizationNameD365,
  //       telephone: event.locator,
  //       billingAttentionD365: event.billingAttentionD365,
  //       billingLocationD365: event.billingLocationD365
  //     }
  //   });
  //   if (this.selectedAccountNumber) {
  //     this.patchValueInCustomerAddressField(
  //       event.partyNumber,
  //       this.selectedAccountNumber
  //     );
  //   }
  //   //this.isCustomerPOFieldRequired(this.selectedAccountNumber); //OptimzationWork 27-02-2025
  //   this.customerBillToObject = event;
  //   this.getBCForSalesOrder(
  //     event.clientAccount,
  //     event.bcPersonnelNumberD365,
  //     'edit'
  //   );
  //   clientProspetToggle.close();

  //   const delivery = this.saleOrderForm.get([
  //     'shipTo',
  //     'addressSelectionName'
  //   ])?.value;
  //   if (
  //     delivery === 'Bill To' ||
  //     delivery == 'Bill to' ||
  //     delivery === 'Client Address Book' ||
  //     delivery === 'Client address book' ||
  //     delivery == 'Address book' ||
  //     delivery == 'To address book'
  //   ) {
  //     this.shipTo.clearNewShifToForm();
  //   }
  // }

  onHeaderUpdate(showLoader = true) {
    if (showLoader) {
      this._loaderService.setLoaderState(true);
    }
    const saleOrderFormObject =
      this.saleOrderForm.getRawValue() as UpdateSalesOrderHeaderDto;

    if (
      this.getD365DefaultProgramsAndSalesClassification.d365DefaultPrgram &&
      saleOrderFormObject.orderHeader &&
      (saleOrderFormObject.orderHeader.programId === 0 ||
        !saleOrderFormObject.orderHeader.programDimensions ||
        saleOrderFormObject.orderHeader.programDimensions?.length <= 0)
    ) {
      this._loaderService.setLoaderState(false);
      this._toastr.error(
        "Error",
        `Missing portal-configured program for the client ${saleOrderFormObject.orderHeader.customerId}`
      );
      return;
    }

    if (
      saleOrderFormObject.orderHeader &&
      !saleOrderFormObject.orderHeader?.shipDate
    ) {
      saleOrderFormObject.orderHeader.shipDate = "";
    }

    // Commented as per the ticket 11595
    if (!saleOrderFormObject.shipTo?.streetD365) {
      if (
        saleOrderFormObject.shipTo?.addressSelectionName?.toLowerCase() !==
          "tbd" &&
        !(
          saleOrderFormObject.shipTo?.addressSelectionName?.toLowerCase() ==
            "multi ship to" ||
          saleOrderFormObject.shipTo?.addressSelectionName?.toLowerCase() ==
            "multiple ship-to" ||
          saleOrderFormObject.shipTo?.addressSelectionName
            ?.toLowerCase()
            .includes("drop")
        )
      ) {
        this._toastr.error("Error", "Address is required");
        this._loaderService.setLoaderState(false);
        return;
      }
    }
    // end of Commented as per the ticket 11595

    // if (
    //   saleOrderFormObject['orderHeader'] &&
    //   !saleOrderFormObject['orderHeader']?.inHandsDate
    // ) {
    //   saleOrderFormObject['orderHeader'].inHandsDate = '';
    // }

    // if (saleOrderFormObject?.shipTo?.streetD365 === "") {
    //   this._toastr.error("Error", "Street address is required");
    //   this._loaderService.setLoaderState(false);
    //   return;
    // }

    if (
      saleOrderFormObject.orderHeader?.shipDate &&
      saleOrderFormObject.orderHeader?.inHandsDate
    ) {
      if (
        new Date(saleOrderFormObject.orderHeader?.inHandsDate) <
        new Date(saleOrderFormObject.orderHeader?.shipDate)
      ) {
        this._loaderService.setLoaderState(false);
        this._toastr.error(
          "Error",
          "Inhands date header greater and equal to ship date header"
        );
        return;
      }
    }

    if (saleOrderFormObject.shipTo) {
      const formValue = this.saleOrderForm.getRawValue();
      const value = formValue.shipTo.shipToVendorAccountNameD365 ?? "";
      saleOrderFormObject.shipTo.deliveryAddressD365 = this.getDeliveryAddress(
        saleOrderFormObject.shipTo.addressSelectionName ?? "",
        saleOrderFormObject.shipTo.deliveryNameD365 ?? "",
        value ?? ""
      );

      saleOrderFormObject.shipTo.shipToD365Address =
        formValue.shipTo.addressD365 ?? "";
    }

    if (this.bcProjectId && saleOrderFormObject.orderHeader) {
      saleOrderFormObject.orderHeader.brandingConsultant = this.bcProjectId;
    }

    // if (
    //   this.bacProjectId &&
    //   saleOrderFormObject.orderHeader &&
    //   this.bacUserDefaultSelectionId
    // ) {
    //   saleOrderFormObject.orderHeader.accountsCoordinator = this.bacProjectId;
    // }

    if (!this.bacUserDefaultSelectionId && saleOrderFormObject.orderHeader) {
      saleOrderFormObject.orderHeader.accountsCoordinator = "";
    }

    // if (
    //   saleOrderFormObject.shipTo &&
    //   saleOrderFormObject.shipTo.addressSelectionName
    //     ?.toLowerCase()
    //     .includes('one')
    // ) {
    //   saleOrderFormObject.shipTo.addressLocationNumber = 0;
    // }

    if (
      saleOrderFormObject.orderDetails != null &&
      saleOrderFormObject.orderHeader != null
    ) {
      saleOrderFormObject.orderDetails.methodOfPayment =
        saleOrderFormObject.orderHeader?.methodOfPaymentHeader;
    }

    if (saleOrderFormObject?.orderDetails && saleOrderFormObject.orderHeader) {
      saleOrderFormObject.orderDetails.buyer =
        saleOrderFormObject.orderHeader.buyer;
    }

    if (this.isMelissaValidationIgnore) {
      this.onSaleOrderNotesSave();
    }

    if (
      saleOrderFormObject?.orderHeader !== null &&
      !saleOrderFormObject?.orderHeader?.programDimensions
    ) {
      saleOrderFormObject.orderHeader.programDimensions = null;
    }

    if (saleOrderFormObject?.orderHeader?.inHandsDate) {
      saleOrderFormObject.orderHeader.inHandsDate =
        this.datepipe.transform(
          saleOrderFormObject?.orderHeader?.inHandsDate,
          "MM/dd/yyyy"
        ) ?? "";
    }

    if (this.saleOrderId) {
      saleOrderFormObject.saleOrderId = this.saleOrderId;
      //saleOrderFormObject.invoiceEmail = this.invoiceEmail;
      this._orderSummaryService
        .updateSaleOrderHeaderData(saleOrderFormObject)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.status.toLowerCase() == "success") {
              if (showLoader) {
                this._toastr.success(
                  "Success",
                  res.message || "Sales Order Header Updated Successfully"
                );
                this.getSaleOrderHeaderData(true);
                this.getSaleOrderLinesData();
                this.disabledSaleOrderHeaderFields();
                this.shipTo.showContinueWithoutValidation = false;
                this.editHeaderStatus = false;
                this.shipTo.salesOrderEditCase = false;
              }
            } else {
              this._toastr.error(
                "Error",
                res.message || "Error updating order"
              );
            }
          },
          error: res => {
            this._loaderService.setLoaderState(false);
            this._toastr.error("Error", res.message || "Error updating order");
          },
        });
    }
  }

  calculateEstimatedTax(event: FocusEvent) {
    const target = event.target as HTMLInputElement;
    let estimatedTax = target.value.replace(/[^a-zA-Z0-9.]/g, "");
    estimatedTax = estimatedTax.substring(0, 10);
    const regExp = /^\d*\.?\d*$/;
    const revenue = regExp.test(estimatedTax) ? "valid" : "invalid";
    if (revenue === "valid" && estimatedTax !== "") {
      this.estimatedTax = parseFloat(estimatedTax);
      if (estimatedTax === "" || estimatedTax === "0") {
        this.orderTotal = this.orderTotal - this.oldEstimatedTax;
      } else {
        this.orderTotal =
          parseFloat(estimatedTax) +
          parseFloat(this.subTotal) +
          this.estimatedFreight;
      }
      this.patchValueInEstimatedTax(estimatedTax);
      this.oldEstimatedTax = parseFloat(estimatedTax);
      this.saleOrderForm.patchValue({
        estimatedOrderTotals: {
          orderTotal: this.orderTotal,
        },
      });
    } else {
      target.value = "";
      this.clearEstimatedForm();
    }
  }

  getDeliveryAddress(
    addressSelectionName: string,
    deliveryNameD365: string,
    shipToVendorAccountNameD365: string
  ) {
    if (addressSelectionName.toLowerCase().includes("one")) {
      return deliveryNameD365;
    } else if (addressSelectionName.toLowerCase().includes("bill")) {
      return deliveryNameD365;
    } else if (addressSelectionName.toLowerCase().includes("vendor")) {
      return shipToVendorAccountNameD365;
    } else if (addressSelectionName.toLowerCase().includes("address")) {
      return deliveryNameD365;
    } else if (addressSelectionName.toLowerCase().includes("branding")) {
      return deliveryNameD365;
    }
    return "";
  }

  calculateEstimatedFreight(event: FocusEvent) {
    const target = event.target as HTMLInputElement;
    let estimatedFreight = target?.value.replace(/[^a-zA-Z0-9.]/g, "");
    estimatedFreight = estimatedFreight.substring(0, 10);
    const regExp = /^\d*\.?\d*$/;
    const revenue = regExp.test(estimatedFreight) ? "valid" : "invalid";
    if (revenue === "valid" && estimatedFreight !== "") {
      this.estimatedFreight = parseFloat(estimatedFreight);
      if (estimatedFreight === "" || estimatedFreight === "0") {
        this.orderTotal = this.orderTotal - this.oldEstimatedFreight;
      } else {
        this.orderTotal =
          parseFloat(estimatedFreight) +
          parseFloat(this.subTotal) +
          this.estimatedTax;
      }
      this.patchValueInEstimatedFreight(estimatedFreight);
      this.oldEstimatedFreight = parseFloat(estimatedFreight);
      this.saleOrderForm.patchValue({
        estimatedOrderTotals: {
          orderTotal: this.orderTotal,
        },
      });
    } else {
      if (target) {
        target.value = "";
      }
      this.clearEstimatedForm();
    }
  }

  clearEstimatedForm() {
    this.estimatedTax = 0;
    this.estimatedFreight = 0;
    this.orderTotal = parseFloat(this.subTotal);
    this.saleOrderForm.patchValue({
      estimatedOrderTotals: {
        orderTotal: this.subTotal,
        estimatedTax: 0,
        estimatedFreight: 0,
      },
    });
  }

  patchValueInEstimatedTax(tax: string) {
    this.saleOrderForm.patchValue({
      estimatedOrderTotals: {
        estimatedTax: parseFloat(tax),
      },
    });
  }

  patchValueInEstimatedFreight(freight: string) {
    this.saleOrderForm.patchValue({
      estimatedOrderTotals: {
        estimatedFreight: parseFloat(freight),
      },
    });
  }

  calculateRecommendedTax() {
    //Logic as per the ticket #13204
    const selectionName = this.saleOrderForm.get([
      "shipTo",
      "addressSelectionName",
    ])?.value as string;
    if (
      selectionName?.toLowerCase() === "tbd" ||
      selectionName?.toLowerCase()?.includes("multi")
    ) {
      this._toastr.error(
        "Error",
        "Can't calculate Tax for incomplete ShipTo address"
      );
      return;
    }
    //end of the logic as per the ticket #13204

    this._loaderService.setLoaderState(true);
    this._orderSummaryService
      .getRecommendedTax(this.saleOrderId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (typeof res.data == "number") {
            this.patchValueInRecommendedTaxCalculate(res.data);
            // this.patchValueInEstimatedFreightCalculate(0);
            // this.patchValueInEstimatedTaxCalculate(0);
            // this.clearEstimatedForm();
            //this.onHeaderUpdate(false);
            this._loaderService.setLoaderState(false);
            this._toastr.success(
              "Success",
              res.message || "Tax Calculated Successfully"
            );
            return;
          }

          this._loaderService.setLoaderState(false);
          this._toastr.error(
            "Error",
            res.message || "Error While Calculating Tax"
          );
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error(
            "Error",
            res.message || "Error While Calculating Tax"
          );
        },
      });
  }

  patchValueInEstimatedTaxCalculate(estimatedTax: number) {
    this.saleOrderForm.patchValue({
      estimatedOrderTotals: {
        estimatedTax: estimatedTax,
      },
    });
    this.estimatedTax = estimatedTax;
    this.calculateOrderTotal();
  }

  patchValueInEstimatedFreightCalculate(estimatedFreight: number) {
    this.saleOrderForm.patchValue({
      estimatedOrderTotals: {
        estimatedFreight: estimatedFreight,
      },
    });
    this.estimatedFreight = estimatedFreight;
    this.calculateOrderTotal();
  }

  patchValueInRecommendedTaxCalculate(recommendedTax: number) {
    this.saleOrderForm.patchValue({
      estimatedOrderTotals: {
        recommendedTax: recommendedTax,
      },
    });
    this.recommendedTax = recommendedTax;
  }

  patchValueInOrderTotal(orderTotal: number) {
    this.saleOrderForm.patchValue({
      estimatedOrderTotals: {
        orderTotal: orderTotal,
      },
    });
  }

  onBrandingConsultantSelection(
    event: MouseEvent,
    drop: Popover,
    target: HTMLDivElement
  ) {
    this.showSmallLoader = true;
    drop.show(event, target);
  }

  showSeeAllButtonEvent(event: boolean) {
    this.showSeeAllButtonTracking = event;
  }

  onProjectIdSelection(event: GetBCForSalesOrderDto, dropdown: Popover) {
    this.brandingConsultantObject = event;
    this.patchProjectIdInBCField(event);
    this.bcProjectId = event.personnelNumber;
    this.getBacForSaleOrderEdit(event.personnelNumber);
    dropdown.hide();
  }

  patchProjectIdInBCField(event: GetBCForSalesOrderDto) {
    this.saleOrderForm.patchValue({
      orderHeader: {
        brandingConsultant: event.projectName,
      },
    });
  }

  b64toBlob(b64Data: string, contentType = "", sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  printProjectConfirmation() {
    this.poEmailData.saleOrderId = this.saleOrderId;
    this.poEmailData.poNumber = "0";
    this.poEmailData.windowState = EnumOrderEmailState.ProjectConfirmation;
    this.poEmailDisplayModal = true;
    // this.router.navigate([
    //   `/orders/po-email/${this.saleOrderId}/${0}/${
    //     EnumOrderEmailState.ProjectConfirmation
    //   }`
    // ]);
  }

  closeModalForPoEmail() {
    this.poEmailDisplayModal = false;
  }

  printProjectApproval() {
    this.poEmailData.saleOrderId = this.saleOrderId;
    this.poEmailData.poNumber = "0";
    this.poEmailData.windowState = EnumOrderEmailState.PrintProjectApproval;
    this.poEmailDisplayModal = true;

    // this.pdfSmallLoader = true;
    // this._orderSummaryService
    //   .printProjectApproval(this.saleOrderId, forced)
    //   .pipe(untilDestroyed(this))
    //   .subscribe({
    //     next: (res) => {
    //       this.pdfSmallLoader = false;
    //       if (res.status.toLowerCase() == 'success') {
    //         this._toastr.success(
    //           res.message || 'PDF Fetched Successfully',
    //           'Success'
    //         );
    //         window.open(res.data, '_blank');
    //         this.getSaleOrderHeaderData(true);
    //         this.getSaleOrderLinesData();
    //       } else {
    //         this._toastr.error(
    //           res.message || 'Error While Fetching Confirmation Journal D365',
    //           'Error'
    //         );
    //       }
    //     },
    //     error: (err) => {
    //       this.pdfSmallLoader = false;
    //       this._toastr.error(
    //         err.message || 'Something Went Wrong While Creating PDF',
    //         'Error'
    //       );
    //     }
    //   });
  }

  getPurchaseOrderId(saleOrderId: string, directDeliveryVendor: string) {
    const purchaseOrder: GetExtisingPOIdRequest = {
      SaleOrderId: saleOrderId,
      DirectDeliveryVendor: directDeliveryVendor,
    };

    this._orderSummaryService
      .GetExtisingPOId(purchaseOrder)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data) {
            if (res.data.PurchaseOrderIds) {
              this.purchaseOrderIdList = res.data.PurchaseOrderIds;
            }
          }
        },
      });
  }

  callgetPurchaseOrderId(vendorId: string) {
    if (vendorId) {
      this.getPurchaseOrderId(this.saleOrderId, vendorId);
    }
  }

  getUserProfile() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe((res: GenericResponseDto<ValidateLogin>) => {
        this.getUserById(res?.data?.userId);
      });
  }

  getUserById(userId: number) {
    this._profileFormService.getUsersById(userId).subscribe({
      next: async res => {
        if (res?.data) {
          this.userObject = res.data;
          this.userPersonnelNumber = res?.data?.personnelNumber;
          this.netCommissionVisibleForBC(res?.data);
          this.getSalesOrderCommissionBc(this.userPersonnelNumber);
        }
      },
    });
  }

  netCommissionVisibleForBC(data: GetUserDto) {
    if (
      data?.userRoleId === UserRole.Admin ||
      data?.personnelNumber === this.bcPersonnelNumber
    ) {
      this.netCommissionStatus = true;
    } else {
      this.netCommissionStatus = false;
    }
  }

  copyHeader() {
    this.displayModal = true;
    this.copyheader.getAllSalesOrderHeader();
  }

  closeModalDialog() {
    this.displayModal = false;
  }

  refreshGrid() {
    this.getSaleOrderHeaderData(this.loaderStatus);
    this.getSaleOrderLinesData();
    this.getSalesOrderInvoiceEmails();
  }

  saleOrderRedirect(url: string) {
    this.saleOrderId = url;
    const urls = "/orders/order-summary/" + url;
    this.router.navigate([urls]);
    this.ngOnInit();
  }

  ProposalRedirect(url: string) {
    this.saleOrderId = url;
    const urls = "/proposal/quote-summary/" + url;
    this.router.navigate([urls]);
    this.ngOnInit();
  }

  addAndRemoveButtons = true;

  editInvoiceEmail() {
    if (this.salesOrderStatusD365.toLowerCase() !== "invoiced") {
      //this.editHeaderStatus = true;
      this.updateButtonValidation = false;
      this.saleOrderForm
        .get(["estimatedOrderTotals", "invoiceEmail"])
        ?.enable();
      this.enableInvoiceEmail();
      this.addAndRemoveButtons = false;
      this.displayEmailInvoiceModal = true;
    } else {
      this.saleOrderForm
        .get(["estimatedOrderTotals", "invoiceEmail"])
        ?.disable();
      this.disabledInvoiceEmail();
      this.addAndRemoveButtons = true;
      this.displayEmailInvoiceModal = false;
    }
  }

  closeInvoiceEmailModel() {
    this.displayEmailInvoiceModal = false;
    this.getSalesOrderInvoiceEmails();
  }

  isEmailInvoiced(invoicedEmail: InvoiceEmail[]): boolean {
    for (const email of invoicedEmail) {
      if (email.invoice) {
        return true;
      }
    }
    return false;
  }

  isEmailValid(invoicedEmail: InvoiceEmail[]): boolean {
    let isEmail = true;
    for (const item of invoicedEmail) {
      const email: string = item.email;
      const regex = `^[a-zA-Z0-9._%+-]+(?:'[a-zA-Z0-9._%+-]+)?@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$`;
      if (!RegExp(regex).exec(email.trim())) {
        isEmail = false;
      }
    }
    if (isEmail) {
      return true;
    }
    return false;
  }

  isEmailDuplicate(): boolean {
    const control = this.saleOrderForm.get("invoicedEmail") as FormArray;
    const emailSet = new Set();
    for (let i = 0; i < control.length; i++) {
      emailSet.add((control.at(i) as FormGroup).get("email")?.value);
    }
    return control.length != emailSet.size;
  }

  // EmailDuplicate(invoicedEmail: InvoiceEmail[]): boolean {
  //   for (let i = 0; i < invoicedEmail.length; i++) {
  //     const email = invoicedEmail[i].email;
  //     for (let j = i + 1; j < invoicedEmail.length; j++) {
  //       if (email === invoicedEmail[j].email) {
  //         this._toastr.error(
  //           'Error',
  //           `Email address "${email}". The record already exists.`
  //         );
  //         return true;
  //       }
  //     }
  //   }
  //   return false;
  // }

  saveInvoiceEmailModel(invoicedEmail: InvoiceEmail[]) {
    if (!this.isEmailInvoiced(invoicedEmail)) {
      this._toastr.error("Error", "Atleast one email should be invoiced");
      return;
    }
    // if (this.EmailDuplicate(invoicedEmail)) {
    //   return;
    // }
    // if (this.invoiceEmailDuplicate(invoicedEmail)) {
    //   return;
    // }

    if (invoicedEmail.length > 0) {
      for (const item of invoicedEmail) {
        if (!item.email) {
          this._toastr.error("Error", "Email is required");
          return;
        }
      }
    }

    this.displayEmailInvoiceModal = false;
    // this.editHeaderStatus = true;
    // this.invoiceEmail = [];
    // (this.saleOrderForm.get('invoicedEmail') as FormArray).controls.forEach(
    //   (x) => {
    //     this.invoiceEmail.push({
    //       id: x?.value?.id === null ? 0 : x.value.id,
    //       email: x?.value?.email === null ? '' : x.value.email,
    //       name: x?.value?.name === null ? '' : x.value.name,
    //       purpose: x?.value?.purpose === null ? '' : x.value.purpose,
    //       save: x.value.save === null ? false : x.value.save,
    //       exist: x?.value?.exist === null ? false : x.value.exist,
    //       confirmation:
    //         x?.value?.confirmation === null ? false : x.value.confirmation,
    //       invoice: x?.value?.invoice === null ? false : x.value.invoice,
    //       salesOrderIdD365:
    //         x?.value?.salesOrderIdD365 === null ? '' : x.value.salesOrderIdD365,
    //       invoiceEmailRecIdD365:
    //         x?.value?.invoiceEmailRecIdD365 === null
    //           ? 0
    //           : x.value.invoiceEmailRecIdD365
    //     });
    //   }
    // );

    if (this.invoiceEmail?.length > 0) {
      this.invoiceEmail?.forEach((x, index) => {
        if (x.invoiceEmailRecIdD365 === 0) {
          this.invoiceEmail[index].salesOrderIdD365 = this.saleOrderId;
        }
      });
    }

    const emailMap = new Map<string, InvoiceEmail>();
    for (const email of invoicedEmail) {
      if (email?.email && email.invoice) {
        emailMap.set(email.email, email);
      }
    }

    this.invoiceEmail.forEach(x => {
      const email = invoicedEmail.find(y => y.id == x.id);
      if (email?.email) {
        emailMap.set(email.email, email);
      }
    });

    const invoiceEmail = Array.from(emailMap.values());
    if (!this.isEmailValid(invoiceEmail)) {
      this._toastr.error("Error", "Invalid email format");
      return;
    }
    this._loaderService.setLoaderState(true);

    invoiceEmail.forEach((x: InvoiceEmail) => {
      if (!x.salesOrderIdD365) {
        x.salesOrderIdD365 = this.saleOrderId;
      }
    });

    if (this.saleOrderId) {
      // const invoiceEmailObject = {
      //   saleOrderId: this.saleOrderId,
      //   invoiceEmail: invoiceEmail
      // };

      this._orderSummaryService
        .updateInvoiceEmailSaleOrderHeaderData(invoiceEmail)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: (res: GenericResponseDto<CreateSalesOrderEmailResponseDto>) => {
            this._loaderService.setLoaderState(false);
            //if (res.data) {
            if (res?.data?.Status?.toLowerCase() === "success") {
              this._toastr.success(
                "Success",
                res.message || "Invoice Email Updated Successfully"
              );
            } else {
              this._toastr.error(
                "Error",
                res.message || "Error Updating Invoice Email"
              );
            }
            // this.getSaleOrderHeaderData(true);
            // this.getSaleOrderLinesData();
            this.getSalesOrderInvoiceEmails();
          },
          error: res => {
            this._loaderService.setLoaderState(false);
            this._toastr.error(
              "Error",
              res.message || "Error Updating Invoice Email"
            );
          },
        });
    }
  }

  // invoiceEmailDuplicate(invoicedEmail: InvoiceEmail[]): boolean {
  //   const email = invoicedEmail[invoicedEmail.length - 1]?.email;
  //   const recid =
  //     invoicedEmail[invoicedEmail.length - 1]?.invoiceEmailRecIdD365;
  //   if (!recid) {
  //     for (let j = 0; j < this.invoiceEmails.length; j++) {
  //       if (email === this.invoiceEmails[j].email) {
  //         this._toastr.error(
  //           'Error',
  //           `Email address "${email}". The record already exists.`
  //         );
  //         return true;
  //       }
  //     }
  //   }
  //   return false;
  // }

  removeInvoiceEmailModel(invoicedEmail: InvoiceEmail[]) {
    const arrayobject: number[] = [];
    invoicedEmail?.forEach(x => {
      if (x.invoiceEmailRecIdD365 !== 0) {
        arrayobject.push(x.id);
      } else {
        const index = this.invoiceEmails.findIndex(y => y.id == x.id);
        if (index >= 0) {
          this.invoiceEmails.splice(index, 1);
        }
      }
    });

    if (arrayobject.length > 0) {
      this._loaderService.setLoaderState(true);
      this._orderSummaryService
        .deleteInvoiceEmailSaleOrderHeaderData(arrayobject)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: (res: GenericResponseDto<CreateSalesOrderEmailResponseDto>) => {
            this._loaderService.setLoaderState(false);
            if (res?.data?.Status?.toLowerCase() === "success") {
              this._toastr.success(
                "Success",
                res.message || "Invoice email delete successfully"
              );
            } else {
              this._toastr.error(
                "Error",
                res.message || "Error deleting invoice email"
              );
            }

            this.getSalesOrderInvoiceEmails();
          },
          error: res => {
            this._loaderService.setLoaderState(false);
            this._toastr.error(
              "Error",
              res.message || "Error deleting invoice email"
            );
          },
        });
    }
  }

  private enableInvoiceEmail() {
    (this.saleOrderForm.get("invoicedEmail") as FormArray).controls.forEach(
      group => {
        (group.get("name") as FormControl).enable();
        (group.get("purpose") as FormControl).enable();
        (group.get("email") as FormControl).enable();
        (group.get("confirmation") as FormControl).enable();
        (group.get("invoice") as FormControl).enable();
      }
    );
  }

  private disabledInvoiceEmail() {
    (this.saleOrderForm.get("invoicedEmail") as FormArray).controls.forEach(
      group => {
        (group.get("name") as FormControl).disable();
        (group.get("purpose") as FormControl).disable();
        (group.get("email") as FormControl).disable();
        (group.get("confirmation") as FormControl).disable();
        (group.get("invoice") as FormControl).disable();
      }
    );
  }

  redirectToFreightChargesPage() {
    if (this.saleOrderModalStatus) {
      this.freightChargesDisplayModal = true;
    } else {
      this.freightChargesDisplayModal = false;
      const url = `/orders/freight-charges/${this.saleOrderId}`;
      this.router.navigate([url]);
    }
  }

  getFreightChargesData() {
    this._orderSummaryService
      .getFreightChargesData(this.saleOrderId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data) {
            if (res.data) {
              this.freightChargeAmount = res.data;
            }
          }
        },
      });
  }

  IsUserBlockedFromEdit() {
    this._orderSummaryService
      .IsUserBlockedFromEdit(this.saleOrderId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.userBlockedFromEdit = res.data;
        },
        error: () => {
          this.userBlockedFromEdit = false;
        },
      });
  }

  openSideBarForOrderNotes() {
    this.displaySidebar = true;
    this.ordernotessidebar?.clearOrderNoteForm();
  }

  closeSideBarForOrderNotes() {
    this.displaySidebar = false;
  }

  getSalesOrderNotes() {
    this.ordernotes.getSalesOrderNotes(this.saleOrderId);
  }

  updateSideBarForOrderNotes() {
    this.ordernotes.updateSingleLine();
  }

  updateLineOnSideBar(selectedOrderNotesGridListing: SalesOrderNotes[]) {
    if (selectedOrderNotesGridListing?.length > 0) {
      this.displaySidebar = true;
      this.ordernotessidebar?.patchValueInOrderNote(
        selectedOrderNotesGridListing[0]
      );
    }
  }

  deleteSideBarForOrderNotes() {
    this.ordernotes.deleteSaleOrderNotes();
  }

  printAllPOs() {
    this._loaderService.setLoaderState(true);
    this._orderSummaryService.printAllPOs(this.saleOrderId).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (!res.data) {
          this._toastr.error("Error", res.message || "Failed To Load PDF");
          return;
        }
        const blob = this.b64toBlob(res.data, "application/pdf");
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl);
      },
      error: () => {
        this._loaderService.setLoaderState(false);
        this._toastr.error("Error", "Failed To Load PDF");
      },
    });
  }

  copyCurrentHeader() {
    this.confirmationService.confirm({
      message: "Are you sure you want to copy this Order?",
      accept: () => {
        this.copyHeaderAgainstId();
      },
    });
  }

  copyCurrentHeaderQuote() {
    this.confirmationService.confirm({
      message: "Are you sure you want to copy this order to Proposal?",
      accept: () => {
        this.copyHeaderAgainstIdQuote();
      },
    });
  }

  copyHeaderAgainstIdQuote() {
    const linesArray: QuotesLinePortalKeyDto[] = [];
    this._loaderService.setLoaderState(true);

    this.salesOrderLineQuote?.forEach((x: QuotesLineAddressDto) => {
      const line: QuotesLinePortalKeyDto = {
        ...(x.salesOrderLine! as QuotesLine),
        oldPortalKey: x?.salesOrderLine?.portalKeyD365 ?? null,
        portalKeyD365: uuidv4(),
        lineCopiedFrom: EnumCopiedFrom.IsFromOrder,
      };
      linesArray.push(line);
    });

    const copyLinesDto: CopyLinesDTOQuote = {
      quotesId: this.saleOrderId || "",
      quotesLinePortalKeyDtos: linesArray,
    };

    const copyLineArray: CopyQuotesRequestDto = {
      copyLinesDto: copyLinesDto,
      quotesNumber: this.saleOrderId || "",
      copiedFrom: EnumCopiedFrom.IsFromOrder,
    };

    this._copyLinesService
      .addHeaderDataQuote(copyLineArray)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data) {
            this._toastr.success("Success", res.message);
            this.ProposalRedirect(
              res?.data?.orderHeader?.salesOrderIdD365 ?? ""
            );
          } else {
            this._toastr.error("Error", res.message ?? "Error adding header");
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message ?? "Error adding header");
        },
      });
  }

  copyHeaderAgainstId() {
    const linesArray: SaleOrderLinePortalKeyDto[] = [];
    this._loaderService.setLoaderState(true);

    this.salesOrderLine?.forEach((x: SaleOrderLineAddressDto) => {
      const line: SaleOrderLinePortalKeyDto = {
        ...(x.salesOrderLine! as SalesOrderLine),
        oldPortalKey: x?.salesOrderLine?.portalKeyD365 ?? null,
        portalKeyD365: uuidv4(),
        lineCopiedFrom: EnumCopiedFrom.IsFromOrder,
      };
      linesArray.push(line);
    });
    const copyLinesDto: CopyLinesDto = {
      salesOrderId: this.saleOrderId || "",
      saleOrderLinePortalKeyDtos: linesArray,
    };

    const copyLineArray: CopySalesOrderRequestDto = {
      copyLinesDto: copyLinesDto,
      salesOrderNumber: this.saleOrderId || "",
      copiedFrom: EnumCopiedFrom.IsFromOrder,
    };

    if (
      this.getD365DefaultProgramsAndSalesClassification.d365DefaultPrgram &&
      this.salesOrderProgramList.length <= 0
    ) {
      this._loaderService.setLoaderState(false);
      this._toastr.error(
        "Error",
        `Missing portal-configured program for the client ${this.customerAccountCopyCheck}`
      );
      return;
    }

    this._copyLinesService
      .addHeaderData(copyLineArray)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data) {
            this._toastr.success("Success", res.message);
            this.saleOrderRedirect(res?.data?.SalesOrderId ?? "");
          } else {
            this._toastr.error("Error", res.message || "Error adding header");
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message || "Error adding header");
        },
      });
  }

  onClientRedirect() {
    if (this.editHeaderStatus === false) {
      this.customerId = this.saleOrderForm.get([
        "orderHeader",
        "customerId",
      ])?.value;
      this.clientDisplayModal = true;
      //this.renderer.addClass(document.body, 'height-max');
    }
  }

  onNewClientRedirect() {
    this.customerId = this.saleOrderForm.get([
      "orderHeader",
      "customerId",
    ])?.value;
    if (this.customerId) this.clientDisplayModal = true;
  }

  closeModal() {
    this.clientDisplayModal = false;
    //this.renderer.removeClass(document.body, 'height-max');
  }

  closeModalForFreight() {
    this.freightChargesDisplayModal = false;
  }

  closeModalOnRedirection(event: string) {
    if (event) {
      this.saleOrderRedirect(event);
    }
    this.clientDisplayModal = false;
  }

  ngOnDestroy(): void {
    this.scrollHiddenStatus.emit();
  }

  addScollHiddenClass() {
    if (this.saleOrderModalStatus) {
      this.renderer.addClass(document.body, "p-overflow-hidden");
    }
  }

  loadReleasedProducts() {
    if (!this.customerFinancialDimension) {
      this.getCustomerFinancialDimension(this.customerAccountNumber);
    }
    if (this.orderType === "inventory-sales") {
      this.getAllVariants();
    }
    this.getAllReleaseProduct();
  }

  getPurchaseOrderLine() {
    this._loaderService.setLoaderState(true);
    this._orderSummaryService.getPurchaseOrderLine(this.saleOrderId).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res.data) {
          this.purchaseOrderLine = res.data;
          if (this.purchaseOrderLine.length > 0) {
            this.openPrinfPdfFlag = true;
          } else {
            this.openPrinfPdfFlag = false;
          }

          if (this.purchaseOrderLine.length === 1) {
            this.poEmailData.saleOrderId = this.saleOrderId;
            this.poEmailData.poNumber =
              this.purchaseOrderLine[0].purchaseOrderNumber ?? 0;
            this.poEmailData.windowState = EnumOrderEmailState.PoPrinting;
            this.poEmailDisplayModal = true;
            // const url = `/orders/po-email/${this.saleOrderId}/${this.purchaseOrderLine[0]?.purchaseOrderNumber}`;
            // window.open(url, '_blank');
          } else {
            this.printPdfModal = true;
          }
        }
      },
      error: () => {
        this._loaderService.setLoaderState(false);
      },
    });
  }

  openPrinfPdfModal() {
    this.getPurchaseOrderLine(); // OptimzationWork 27-02-2025
  }

  onOrderTrackingToggle() {
    if (this.expandOrderTrackingStatus) {
      this.collapseOrderTrackingStatus = true;
      this.expandOrderTrackingStatus = false;
      this.setOrderTrackingStateOfExpandAll();
      this.collapseOrderTrackingHeading = "Collapse all";
      this.getProjectId();
    } else {
      this.collapseOrderTrackingStatus = false;
      this.expandOrderTrackingStatus = true;
      this.setOrderTrackingStateOfCollapseAll();
      this.collapseOrderTrackingHeading = "Expand all";
    }
  }

  setOrderTrackingStateOfExpandAll() {
    localStorage.setItem("SalesOrder-Order-Tracking-collapse", "true");
  }

  setOrderTrackingStateOfCollapseAll() {
    localStorage.setItem("SalesOrder-Order-Tracking-collapse", "false");
  }

  getOrderTrackingStateOfCollapseAll() {
    const status = localStorage.getItem("SalesOrder-Order-Tracking-collapse");
    if (status) {
      if (status === "true") {
        this.collapseOrderTrackingStatus = true;
        this.expandOrderTrackingStatus = false;
        this.collapseOrderTrackingHeading = "Collapse all";
      } else {
        this.collapseOrderTrackingStatus = false;
        this.expandOrderTrackingStatus = true;
        this.collapseOrderTrackingHeading = "Expand all";
      }
    }
  }

  openPdfScreen(purchaseOrderId: string) {
    this.poEmailData.saleOrderId = this.saleOrderId;
    this.poEmailData.poNumber = purchaseOrderId;
    this.poEmailData.windowState = EnumOrderEmailState.PoPrinting;
    this.poEmailDisplayModal = true;
    // const url = `/orders/po-email/${this.saleOrderId}/${purchaseOrderId}`;
    // window.open(url, '_blank');
  }

  closePrinfPdfModal() {
    this.printPdfModal = false;
    if (this.saleOrderModalStatus) {
      this.renderer.addClass(document.body, "p-overflow-hidden");
    }
  }

  onContactList(
    event: MouseEvent,
    contactdropdown: Popover,
    target: HTMLDivElement
  ) {
    contactdropdown.show(event, target);
  }

  // applyBuyerLengthValidation(event: any) {
  //   if (event.target.value) {
  //     this.saleOrderForm.patchValue({
  //       orderHeader: {
  //         buyer: event.target.value.substring(0, 50)
  //       }
  //     });
  //   }
  // }

  // onCustomerSelection(name: string, contactdropdown: any) {
  //   contactdropdown.close();
  //   this.saleOrderForm.patchValue({
  //     orderHeader: {
  //       buyer: name
  //     }
  //   });
  // }

  getAllContactsByAccountNumber(accountNumber: string, partyNumber: string) {
    this.showSmallLoader = true;
    this._saleOrderService
      .getAllContactsByAccountNumber(accountNumber, partyNumber)
      .pipe(pluck("data"))
      .subscribe({
        next: data => {
          this.showSmallLoader = false;
          this.clientContacts = data;
          this.transformClientContactData();
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  transformClientContactData() {
    this.ClientAddresses = [];
    // this.saleOrderForm.patchValue({
    //   orderDetails: {
    //     buyer: ''
    //   }
    // });
    // const Business = this.clientContacts?.filter(
    //   (x) => x.purposeD365 == ClientPurposeType.Business
    // );
    // this.populateClientContactInformation(Business);
    // const Invoice = this.clientContacts?.filter(
    //   (x) => x.purposeD365 == ClientPurposeType.Invoice
    // );
    // this.populateClientContactInformation(Invoice);
    // const Payment = this.clientContacts?.filter(
    //   (x) => x.purposeD365 == ClientPurposeType.Payment
    // );
    // this.populateClientContactInformation(Payment);
    // const Delivery = this.clientContacts?.filter(
    //   (x) => x.purposeD365 == ClientPurposeType.Delivery
    // );
    // this.populateClientContactInformation(Delivery);
    // const Other = this.clientContacts?.filter(
    //   (x) => x.purposeD365 == ClientPurposeType.Other
    // );
    // this.populateClientContactInformation(Other);
    // const Buyer = this.clientContacts?.filter(
    //   (x) => x.purposeD365 == ClientPurposeType.Buyer
    // );
    // this.populateClientContactInformation(Buyer);

    //Code as per the task 11016 PGL-206
    this.populateClientContactInformation(this.clientContacts);
  }

  populateClientContactInformation(
    clientContacts: ClientContact[] | undefined
  ) {
    if (
      clientContacts != null &&
      clientContacts != undefined &&
      clientContacts.length > 0
    ) {
      clientContacts.forEach(element => {
        if (element?.locatorD365) {
          const clientAddress: ClientAddressCustomize = {};
          clientAddress.purpose = element.purposeD365;
          clientAddress.isPrimary = element.isPrimaryD365;
          clientAddress.name = element.descriptionD365;
          clientAddress.cust = element.cust;
          clientAddress.title = element.title;
          clientAddress.electronicAddressIdD365 =
            element.electronicAddressIdD365;

          if (element.typeD365 == EnumContactType.Phone) {
            clientAddress.phone = element.locatorD365;
            clientAddress.phoneLink = "tel:'" + element.locatorD365 + "'";
          } else if (element.typeD365 == EnumContactType.Email) {
            clientAddress.email = element.locatorD365;
            clientAddress.emailLink = "mailto:'" + element.locatorD365 + "'";
          }
          if (clientAddress.name) {
            this.ClientAddresses.push(clientAddress);
          }
        }
      });
    }
  }

  printOrderSummary() {
    this.poEmailData.saleOrderId = this.saleOrderId;
    this.poEmailData.poNumber = "0";
    this.poEmailData.windowState = EnumOrderEmailState.PrintOrderSummary;
    this.poEmailDisplayModal = true;
  }

  getSalesOrderCommissionBc(userPersonnelNumber: string) {
    this._orderSummaryService

      .getSalesOrderCommissionBc(this.saleOrderId)

      .subscribe({
        next: async res => {
          if (res?.data) {
            const ifFind = res.data.findIndex(
              x => x.employeeIDD365 == userPersonnelNumber
            );

            if (ifFind != -1 || this.userObject.userRoleId === UserRole.Admin) {
              this.showCommissionsFields = true;
            } else {
              this.showCommissionsFields = false;
            }
          } else {
            this.showCommissionsFields = false;
          }
        },
      });
  }

  addContactInformationBuyer() {
    const getBuyerValue = this.saleOrderForm.get(["orderHeader", "buyer"])
      ?.value as string;
    if (this.customerBillToObject?.clientAccount) {
      const getSplitValues = getBuyerValue.split(" ");
      this.customerAccountNumber = this.customerBillToObject.clientAccount;
      this.addClientContact.firstName = getSplitValues[0] || "";
      this.addClientContact.lastName = getSplitValues[1] || "";
      this.addClientContact.type = "Buyer";
    }
    this.displayAddContact = true;
  }

  addContactInformation() {
    const getBuyerValue = this.saleOrderForm.get(["orderDetails", "buyer"])
      ?.value as string;
    const getSplitValues = getBuyerValue.split(" ");
    this.addClientContact.firstName = getSplitValues[0] ?? "";
    this.addClientContact.lastName = getSplitValues[1] ?? "";
    this.addClientContact.type = "Buyer";
    this.displayAddContact = true;
  }

  isContactAdded(obj: boolean) {
    if (obj) {
      // this.getAllContactsByAccountNumber(
      //   this.customerAccountNumber,
      //   this.partyNumber
      // ); //OptimzationWork 27-02-2025
    }
  }

  populateContactAddedInfo(obj: string) {
    if (obj) {
      this.saleOrderForm.patchValue({
        orderHeader: {
          buyer: obj,
        },
      });
    }
  }

  onBuyerSearchOpenToggle(mydrop: Popover, event: KeyboardEvent) {
    mydrop.show(event);
    const target = event.target as HTMLInputElement;
    if (target.value != "") {
      this.deliveryAddress[1].status = false;
      this.deliveryAddress[2].status = false;
    } else {
      this.deliveryAddress[1].status = true;
      this.deliveryAddress[2].status = true;
    }
  }

  checkLinesProposalIdField() {
    if (this.salesOrderLine?.length > 0) {
      const index = this.salesOrderLine.findIndex(
        x => x?.salesOrderLine?.proposalIdD365 !== ""
      );
      if (index != -1) {
        this.proposalIdD365EditFieldValidation = true;
      }
    }
  }
  modalOpen = false;

  modalOrderProposal() {
    this.modalOpen = true;
  }

  mapSaleOrderLineToQuotesLine(
    saleOrderLine: SaleOrderLineAddressDto
  ): QuotesLineAddressDto {
    return {
      salesOrderLine: saleOrderLine.salesOrderLine as QuotesLine | null,
      address: saleOrderLine.address as Address | null,
      lineFrom: EnumCopiedFrom.IsFromOrder,
    };
  }

  redirectToCopiedFrom() {
    if (this.salesOrderHeaderData?.salesOrderHeader?.copiedFromHeaderId) {
      if (
        this.salesOrderHeaderData?.salesOrderHeader?.copiedFrom ===
        EnumCopiedFrom.IsFromOrder
      ) {
        const url = `/orders/order-summary/${this.salesOrderHeaderData.salesOrderHeader.copiedFromHeaderId}`;
        window.open(url, "_blank");
      } else if (
        this.salesOrderHeaderData?.salesOrderHeader?.copiedFrom ===
        EnumCopiedFrom.IsFromQuote
      ) {
        const url = `/proposal/quote-summary/${this.salesOrderHeaderData.salesOrderHeader.copiedFromHeaderId}`;
        window.open(url, "_blank");
      }
    }
  }

  setCopiedFromInfo() {
    let copiedInfo = "";
    if (this.salesOrderHeaderData?.salesOrderHeader?.copiedFromHeaderId) {
      if (
        this.salesOrderHeaderData.salesOrderHeader.copiedFrom ===
        EnumCopiedFrom.IsFromOrder
      ) {
        copiedInfo =
          " Ord " +
            this.salesOrderHeaderData.salesOrderHeader.copiedFromHeaderId ||
          "" + this.salesOrderHeaderData.salesOrderHeader.createdDate;
      } else if (
        this.salesOrderHeaderData.salesOrderHeader.copiedFrom ===
        EnumCopiedFrom.IsFromQuote
      ) {
        copiedInfo =
          " Proposal " +
            this.salesOrderHeaderData.salesOrderHeader.copiedFromHeaderId ||
          "" + this.salesOrderHeaderData.salesOrderHeader.createdDate;
      }
    }
    return copiedInfo;
  }

  getBuyer(event: Event, mydrop: Popover) {
    this.showSmallLoader = true;
    const keyEvent = event as KeyboardEvent;
    const target = event.target as HTMLInputElement;
    if (keyEvent.key.toLowerCase() === "tab") {
      const buyerValue = target.value;
      const payload = {
        clientAccountNumber: this.customerAccountNumber ?? "",
        buyer: buyerValue,
      } as GetAllBuyersRequestDto;
      this._buyerService
        .getAllBuyers(payload)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.buyerLists = res.data;
            if (this.buyerLists.length > 0) {
              this.onBuyerSelection(this.buyerLists[0], mydrop);
            }
            this.showSmallLoader = false;
          },
          error: () => {
            this.showSmallLoader = false;
          },
        });
    }
  }

  onBuyerSelection(
    event: GetAllBuyersResponseDto,
    buyerProspetToggle: Popover
  ) {
    this.buyerName = event.buyer;
    //this.getCustomerAccountBuyer(event.account);
    this.onCustomerSelectionBuyer(event.buyer);
    buyerProspetToggle.hide();
  }

  onCustomerSelectionBuyer(name: string) {
    this.saleOrderForm.patchValue({
      orderHeader: {
        buyer: name,
      },
    });
  }

  // onBuyerList(buyerdropdown: Popover) {
  //   buyerdropdown.show();
  // }

  searchBuyerName() {
    this.buyerVendor$
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        switchMap((searchitem: string) => {
          if (searchitem) {
            this.smallLoaderEvent.emit(true);
          }

          const request = {
            clientAccountNumber:
              this.saleOrderForm.get(["orderHeader", "customerIdValid"])
                ?.value ||
              this.saleOrderForm.get(["orderHeader", "customerId"])?.value ||
              "",
            buyer: searchitem,
          } as GetAllBuyersRequestDto;

          this.buyerLists = [];
          if (searchitem) {
            return this._buyerService.getAllBuyers(request);
          }
          return EMPTY;
        })
      )
      .subscribe({
        next: (res: GenericResponseDto<GetAllBuyersResponseDto[]>) => {
          if (res.data != null) {
            this.buyerLists = res.data;
          }
          this.smallLoaderEvent.emit(false);
        },
        error: () => {
          this.smallLoaderEvent.emit(false);
        },
      });
  }

  getAllBuyers() {
    const request = {
      clientAccountNumber:
        this.saleOrderForm.get(["orderHeader", "customerIdValid"])?.value ||
        this.saleOrderForm.get(["orderHeader", "customerId"])?.value ||
        "",
      buyer: "",
    } as GetAllBuyersRequestDto;
    if (request.clientAccountNumber == "" && request.buyer == "") {
      return;
    }
    this._buyerService
      .getAllBuyers(request)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.showSmallLoader = false;
          this.buyerLists = res.data;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  ///////////buyer to client logic here /////////////////////

  onClientSelectionBuyer(event: ClientSearchList) {
    this.selectedAccountNumber = event.clientAccount;
    // this.clearInvoiceEmails();
    this.patchValueInCustomerAccount(this.selectedAccountNumber);
    this.customerBillToObject = event;
    this.customerBillToObjectEvent.emit(this.customerBillToObject);
    if (event.clientAccount != "") {
      this.deliveryAddress[1].status = false;
      this.deliveryAddress[2].status = false;
    } else {
      this.deliveryAddress[1].status = true;
      this.deliveryAddress[2].status = true;
    }
    this.patchValueInCustomerNameAndTelephoneField(event);
    this.patchValueInCustomerAccountField(event);
    this.patchValueInCustomerAddressFieldBuyer();
  }

  clearInvoiceEmails() {
    (this.saleOrderForm.get("invoicedEmails") as FormArray).clear();
  }

  patchValueInCustomerAccount(accountNumber: string) {
    this.saleOrderForm.patchValue({
      orderHeader: {
        customerId: accountNumber,
        customerIdValid: accountNumber,
      },
    });

    this.getBuyerEvent.emit();
  }

  patchValueInCustomerAddressFieldBuyer() {
    this._buyerService
      .getCustomerAddressByPartyNumber(
        this.customerBillToObject?.partyNumber,
        this.customerBillToObject?.clientAccount
      )
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: GenericResponseDto<Address[]>) => {
          this.showSmallLoader = false;
          const primaryAddress = res.data.filter(
            x =>
              x.isPrimaryD365?.toLowerCase() === "yes" ||
              x.isPrimaryD365?.toLowerCase() === "1"
          );

          if (primaryAddress.length > 0) {
            if (primaryAddress[0].addressD365) {
              this.patchValuesInCustomerFormAddressField(
                primaryAddress[0].addressD365
              );
            }
          } else {
            this.patchValuesInCustomerFormAddressField("");
          }
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  patchValueInCustomerAccountField(clientObj: ClientSearchList) {
    this.saleOrderForm.patchValue({
      orderHeader: {
        accountNumberD365: clientObj.clientAccount,
      },
    });
  }

  patchValueInCustomerNameAndTelephoneField(clientObj: ClientSearchList) {
    this.saleOrderForm.patchValue({
      customerAddress: {
        name: clientObj.organizationNameD365,
        telephone: clientObj.locator === null ? "" : clientObj.locator,
        billingLocationD365: clientObj.billingLocationD365,
        billingAttentionD365: clientObj.billingAttentionD365,
      },
    });
  }

  // getCustomerAccountBuyer(accountNumber: any) {
  //   this.showSmallLoader = true;
  //   this._buyerService
  //     .getCustomerByNameAndAccountNumberFilter(accountNumber)
  //     .pipe(untilDestroyed(this))
  //     .subscribe({
  //       next: (res) => {
  //         this.customerLists = res.data;
  //         if (this.customerLists.length > 0) {
  //           this.onClientSelectionBuyer(this.customerLists[0]);
  //         }
  //         this.showSmallLoader = false;
  //       },
  //       error: () => {
  //         this.showSmallLoader = false;
  //       }
  //     });
  // }

  sellAllOrderTracking() {
    this.orderTrackingModalStatus = true;
  }

  closeModalForOrderTracking() {
    this.orderTrackingModalStatus = false;
  }

  addIpTrackingLine() {
    this.orderTracking.addIpTrackingLine();
  }

  uploadIpTrackingLine() {
    this.orderTracking.uploadIpTrackingLine();
  }

  deleteIpTrackingLine() {
    this.orderTracking.deleteIpTrackingLine();
  }

  getOrderTracking(invoiceProposalId: string) {
    // const localCacheOrderTracking = localStorage.getItem('order-tracking');
    // if (localCacheOrderTracking) {
    //   const parsedOrderTracking = JSON.parse(localCacheOrderTracking);
    //   if (
    //     parsedOrderTracking &&
    //     parsedOrderTracking?.InvoiceProposalId == invoiceProposalId
    //   ) {
    //     this.orderTrackingGridListing =
    //       parsedOrderTracking?.AllFreightTrackingLines || [];
    //   }
    // } else {

    const payload = {
      ProposalId: invoiceProposalId,
    } as TrackingFreightApiRequestDto;
    this._invoicePreviewSummaryService
      .getOrderTracking(payload)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data?.AllFreightTrackingLines) {
            this.orderTrackingGridListing = res.data.AllFreightTrackingLines;
          }
        },
        error: res => {
          this._toastr.error(
            "Error",
            res.message || "Error In Fetching Freight Details From D365"
          );
        },
      });
    // }
  }

  getCustomerFinancialDimension(customerAccountNumber: string) {
    if (this.orderType == "inventory-sales") {
      this._addNewClientService
        .getCustomerFinancialDimension(customerAccountNumber)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.customerFinancialDimension = res.data;
          },
        });
    }
  }

  getOrderTrackingData() {
    //this.getAllOrderTrackingDataAgainstSaleOrder();
    this.getOrderTrackingDataAgainstSaleOrder(this.saleOrderId, this.projId);
  }

  getOrderTrackingDataAgainstSaleOrder(salesId: string, projId: string) {
    this._loaderService.setLoaderState(true);
    if (salesId && projId) {
      this.saleOrderId = salesId;
      this.projId = projId;
      const oDataFilter = `?$top=${this.defaultTracking}&$filter=SalesId eq '${salesId}'`;
      this._invoicePreviewSummaryService
        .getFreightTrackingLine(oDataFilter)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            res.data.forEach(x => {
              x.PortalKey = uuidv4();
            });
            this.orderTrackingGridListing = res.data;

            if (res?.data?.length === 21) {
              this.showSeeAllButtonTracking = true;
              this.orderTrackingGridListing =
                this.orderTrackingGridListing.slice(
                  0,
                  this.orderTrackingGridListing.length - 1
                );
            }

            this._loaderService.setLoaderState(false);
          },
          error: () => {
            this._loaderService.setLoaderState(false);
          },
        });
    }
  }

  getIRBillingReviewStatus() {
    if (this.saleOrderId) {
      this._saleOrderService
        .getIRBillingReviewStatus(this.saleOrderId)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            if (res?.data) {
              this.displayIROrderStatusReview = true;
              this.getIRBillingReviewStatusResposne = res?.data;
            }
          },
        });
    }
  }

  openProFormaInvoice(reportType: string) {
    this.reportType = reportType;
    if (reportType === "proFormaInvoice") {
      this.showProFormalDialogHeading = "Pro Forma Invoice";
    }

    if (reportType === "depositInvoice") {
      this.showProFormalDialogHeading = "Deposit Invoice";
    }

    this.showProFormalDialog = true;

    this.salesOrderLineReport = this.salesOrderLine.filter(
      x => x.salesOrderLine?.id ?? 0 > 0
    );
  }

  setCategoryNameToLines() {
    this.salesOrderLine.forEach(x => {
      if (x.salesOrderLine) {
        x.salesOrderLine.categoryName =
          this.releasedProductsList.find(
            y => y.itemNumberD365 == x.salesOrderLine?.itemNumberD365
          )?.nameD365 ?? "";
      }
    });
  }

  getAllVariants() {
    this._samplepoListingService
      .getAllVariants()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.releasedProductsVariantsList = res.data.filter(
            item => item.poStopped === "No"
          );
        },
      });
  }

  closeModalForProReport() {
    this.showProFormalDialog = false;
  }

  checkOrderIsConfirmed() {
    if (
      this.approvalStatusD365 &&
      this.approvalStatusD365?.toLowerCase() !== "none"
    ) {
      return true;
    } else {
      return false;
    }
  }

  IsSalesOrderInvoiced() {
    if (this.salesOrderLine.length > 0) {
      const filterList = this.salesOrderLine.filter(x => {
        if (
          x.salesOrderLine?.proposalIdD365 &&
          x.salesOrderLine?.proposalIdD365 !== ""
        ) {
          return true;
        } else {
          return false;
        }
      });

      if (filterList.length > 0) {
        this.isLineEditDisabled = false;
      } else {
        this.isLineEditDisabled = true;
      }
    } else {
      this.isLineEditDisabled = true;
    }
  }

  isAnyUnCommitLinesEvent(obj: boolean) {
    this.isAnyUnCommitLines = obj;
  }

  refreshOrderLinesGridEvent() {
    this.ngOnInit();
  }

  IsPartiallyInvoicedOrder() {
    if (
      this.salesOrderLine.length > 0 &&
      this.salesOrderStatusD365?.toLowerCase() === "open order"
    ) {
      const isInIp = this.salesOrderLine.filter(
        x =>
          x.salesOrderLine?.proposalIdD365 &&
          x.salesOrderLine?.proposalIdD365 !== ""
      );
      const isAnyOpenLines = this.salesOrderLine.filter(
        x =>
          x.salesOrderLine?.lineStatusD365 &&
          x.salesOrderLine?.lineStatusD365 === "Open order"
      );
      const isAnyInvoicedLines = this.salesOrderLine.filter(
        x =>
          x.salesOrderLine?.lineStatusD365 &&
          x.salesOrderLine?.lineStatusD365 === "Invoiced"
      );

      if (
        isInIp &&
        isInIp?.length > 0 &&
        isAnyOpenLines &&
        isAnyOpenLines.length > 0 &&
        isAnyInvoicedLines &&
        isAnyInvoicedLines.length > 0
      ) {
        this.isLineEditDisabled = true;
        this.isPartiallyInvoicedOrderLines = true;
      }
    }
  }

  getAllOrderTrackingDataAgainstSaleOrder() {
    if (this.saleOrderId) {
      const oDataFilter = `?$filter=SalesId eq '${this.saleOrderId}'`;
      this._invoicePreviewSummaryService
        .getFreightTrackingLine(oDataFilter)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.orderTrackingGridListingExcel = res.data;
          },
        });
    }
  }

  exportExcelForOrderTrackingData() {
    const object = this.orderTrackingGridListing.map(datum => {
      return {
        ["PO #"]: datum?.PurchId,
        ["Bill Rec"]: datum?.BillRecieved,
        ["JNIAcct"]: datum?.FreightAccount,
        ["Ship Date"]: datum?.ShipDate,
        ["Deliv Date"]: datum?.DeliveryDate,
        ["Carrier"]: datum?.Carrier === "All" ? "" : datum?.Carrier,
        ["Tracking"]: datum?.TrackingNumber,
        ["Weight"]: datum?.Weight,
        ["Sale Price"]: datum?.SellPrice,
        ["Ship Method"]: datum?.DlvModeDescription,
        ["Shipper Name"]: datum?.ShipperName,
        ["Shipped From"]: datum?.ShipFromAddress,
        ["S-Ctry"]: datum?.ShipperCountry,
        ["Recipient Name"]: datum?.RecipientName,
        ["Recipient Address"]: datum?.ShipToAddress,
        ["R-Ctry"]: datum?.RecipientCountry,
        ["Sales Order"]: datum?.SalesId,
        ["JNI Reference 2"]: datum?.JNIReference2,
        ["JNI Reference 3"]: datum?.JNIReference3,
        ["JNI Reference 4"]: datum?.JNIReference4,
        ["JNI Reference 5"]: datum?.JNIReference5,
      };
    });

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(object);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "OrderTracking");
    });
  }

  saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
    const EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  openWorkflowModal() {
    this.showWorkflowDialog = true;
    this.fromOrderSummary = true;
  }

  closeWorkflowModal() {
    if (this.projectHasUnsavedChanges) {
      this.confirmProjectSummaryClose();
    } else {
      this.showWorkflowDialog = false;
      this.fromOrderSummary = false;
      this.getSalesOrderAssignedProject();
    }
  }

  closeProjectAssignModal() {
    this.showProjectAssignDailog = false;
  }

  assignProjectToOrder() {
    this._loaderService.setLoaderState(true);
    if (!this.projectWorkflowId || this.projectWorkflowId === 0) {
      this._toastr.error("Error", "Select a Project to assign to Sales Order");
      this._loaderService.setLoaderState(false);
      return;
    }
    const payload: AssignOrderToProjectDto = {
      salesOrderIdD365: this.saleOrderId,
      projectWorkflowId: Number(this.projectWorkflowId),
    };
    this._orderSummaryService
      .postAssignedProjectToSalesOrder(payload)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.projectWorkflowId = 0;
          this.paddedProjectWorkflowId = "";
          this.closeProjectAssignModal();
          if (res?.data) {
            this._toastr.success(
              "Success",
              "Project Assigned to Sales Order Successfully"
            );
            this.getSalesOrderAssignedProject();
          } else {
            this._toastr.error(
              "Error",
              "Failed to assign project to Sales Order"
            );
          }
          this._loaderService.setLoaderState(false);
        },
        error: () => {
          this._toastr.error(
            "Error",
            "Failed to assign project to Sales Order"
          );
          this._loaderService.setLoaderState(false);
        },
      });
  }

  getPreSalesProjectList() {
    this.pdfSmallLoader = true;
    this._orderSummaryService
      .getPreSalesProjectList(
        this.salesOrderHeaderData?.salesOrderHeader?.customerIdD365 ?? ""
      )
      .subscribe({
        next: res => {
          this.pdfSmallLoader = false;
          this.showProjectAssignDailog = true;
          if (res?.data) {
            this.preSalesProjectList = res?.data;
          }
        },
        error: () => {
          this.pdfSmallLoader = false;
          this._toastr.error("Error", "Unable to get Projects");
        },
      });
  }

  getSalesOrderAssignedProject() {
    this._orderSummaryService
      .getSalesOrderAssignedProject(this.saleOrderId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res?.data && res?.data !== 0) {
            this.projectWorkflowId = res?.data;
            this.paddedProjectWorkflowId = res?.data
              .toString()
              .padStart(6, "0");
            this.workflowAssigned = true;
          } else {
            this.projectWorkflowId = 0;
            this.paddedProjectWorkflowId = "";
            this.workflowAssigned = false;
          }
        },
      });
  }

  onChangeProjectWorkflowSelection(event: SelectChangeEvent) {
    if (event.value) {
      const value = event.value as number;
      this.paddedProjectWorkflowId = value.toString().padStart(6, "0");
      this.projectWorkflowId = value;
    } else {
      this.paddedProjectWorkflowId = "";
      this.projectWorkflowId = 0;
    }
  }

  confirmProjectCreate() {
    this.confirmationService.confirm({
      message: `Are you sure that you want to create a new Project with Sales Order ${this.saleOrderId}?`,
      acceptLabel: "Yes",
      rejectLabel: "No",
      accept: () => {
        this.openWorkflowModal();
      },
    });
  }

  confirmAssignProjectToOrder() {
    this.confirmationService.confirm({
      message: `Are you sure that you want to Link Sales Order ${
        this.saleOrderId
      } to ${this.projectWorkflowId.toString().padStart(6, "0")} Project ?`,
      acceptLabel: "Yes",
      rejectLabel: "No",
      accept: () => {
        this.assignProjectToOrder();
      },
    });
  }

  isMelissaValidationIgnoreEvent(value: boolean) {
    this.isMelissaValidationIgnore = value;
  }

  onSaleOrderNotesSave() {
    if (this.saleOrderId) {
      const obj: SalesOrderNotes = {
        salesOrderId: this.saleOrderId,
        portalKey: uuidv4(),
        description: "System Order # " + this.saleOrderId,
        id: 0,
        note: "Non approved address was accepted",
        purchaseOrderStatus: false,
        type: "Order note",
        purchaseOrderId: "",
        createdDate: "",
        createdBy: "",
        lastModifiedDate: null,
        lastModifiedBy: null,
        isActive: false,
      };

      this._orderNotesSidebarService
        .AddSalesOrderNotes(obj)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: () => {
            this.getSalesOrderNotes();
          },
        });
    }
  }

  getProgramDetails($event: ProgramListDto | ProgramClientListDto) {
    if ($event && "programId" in $event && "dimensionNameD365" in $event) {
      this.saleOrderForm.patchValue({
        orderHeader: {
          programId: $event.programId,
        },
      });

      if ($event.dimensionD365 && $event.dimensionD365 !== "") {
        this.saleOrderForm.patchValue({
          orderHeader: {
            programDimensions: [
              {
                displayValue: $event.dimensionD365,
                displayName: $event.dimensionNameD365,
              },
            ],
          },
        });
      } else {
        this.saleOrderForm.patchValue({
          programDimensions: [],
        });
      }

      //this.getProgramNameById($event.programId ?? 0); OptimzationWork 27-02-2025
      const customerId =
        this.saleOrderForm.get(["orderHeader", "customerIdValid"])?.value ||
        this.saleOrderForm.get(["orderHeader", "customerId"])?.value ||
        "";
      if (!customerId || customerId === "") {
        this.pdfSmallLoader = true;
        this._customerAccountService
          .getCustomerByNameAndAccountNumberFilter($event.clientAccount)
          .pipe(untilDestroyed(this))
          .subscribe({
            next: res => {
              this.saleOrderForm.get(["orderHeader", "buyer"])?.disable();
              const customerLists = res.data;
              if (customerLists.length > 0) {
                this.onClientSelectionBuyer(customerLists[0]);
              }
              this.saleOrderForm.patchValue({
                orderHeader: {
                  customerIdValid: customerLists[0].clientAccount,
                  customerId: customerLists[0].clientAccount,
                },
              });
              //this.getAllBuyers(); //OptimzationWork 27-02-2025
              this.saleOrderForm.get(["orderHeader", "buyer"])?.enable();
              this.pdfSmallLoader = false;
            },
            error: () => {
              this.pdfSmallLoader = false;
            },
          });
      }
    }
  }

  getPDFLoaderStatus(status: boolean) {
    this.pdfSmallLoader = status;
  }

  disableBuyerFeild() {
    // if (status) {
    //   if (!this.saleOrderForm.get(['orderHeader', 'buyer'])?.disabled) {
    //     this.saleOrderForm.get(['orderHeader', 'buyer'])?.disable();
    //   }
    // } else {
    //   this.saleOrderForm.get(['orderHeader', 'buyer'])?.enable();
    // }
  }

  getProgramNameById(programId: number) {
    if (programId && programId > 0) {
      this._programService
        .getProgarmDetailsById(programId)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            if (res?.data) {
              this.programName = res.data.name;
              if (res.data.dimensionD365 && res.data.dimensionD365 !== "") {
                this.saleOrderForm.patchValue({
                  orderHeader: {
                    programId: res?.data.id,
                    programDimensions: [
                      {
                        displayValue: res.data.dimensionD365,
                        displayName: "Program",
                      },
                    ],
                  },
                });
              } else {
                this.saleOrderForm
                  .get(["orderHeader", "programId"])
                  ?.setValue(res.data.id ?? 0);
                this.programs.programId = res.data.id ?? 0;
              }
            }
          },
        });
    }
  }

  showAllOrderNotesOrNot() {
    this.showAllOrderNotes = !this.showAllOrderNotes;
  }

  getCustomerAccountDefaultDimensions(customerAccount: string) {
    if (customerAccount) {
      this._programService
        .getD365DefaultProgramsAndSalesClassificationByClient(customerAccount)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            if (res?.status === "Success" && res?.data) {
              this.getD365DefaultProgramsAndSalesClassification = res.data;
            }
          },
        });
    }
  }

  getAllProgramsByCustomer(customerAccount: string) {
    if (customerAccount) {
      this.customerAccountCopyCheck = customerAccount;
      this._programService
        .getProgramByNameFilterForSalesOrder("", customerAccount)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.salesOrderProgramList = res.data;
          },
        });
    }
  }

  canDeactivate(): Observable<boolean> | boolean {
    if (this.projectHasUnsavedChanges) {
      return new Observable<boolean>(observer => {
        this.confirmationService.confirm({
          message: "You have unsaved changes. Do you really want to leave?",
          acceptLabel: "Yes",
          rejectLabel: "No",
          accept: () => {
            this.projectHasUnsavedChanges = false;
            observer.next(true);
            observer.complete();
          },
          reject: () => {
            observer.next(false);
            observer.complete();
          },
        });
      });
    } else {
      return true;
    }
  }

  onInputChange(event: boolean) {
    this.projectHasUnsavedChanges = event;
  }

  confirmProjectSummaryClose() {
    this.confirmationService.confirm({
      message: "You have unsaved changes. Do you really want to leave?",
      acceptLabel: "Yes",
      rejectLabel: "No",
      accept: () => {
        this.showWorkflowDialog = false;
        this.fromOrderSummary = false;
        this.projectHasUnsavedChanges = false;
        this.getSalesOrderAssignedProject();
      },
      reject: () => {
        this.projectHasUnsavedChanges = true;
      },
    });
  }

  // Logic implemented as per the ticket #13023 comments
  IsSalesOrderDeliveredWithInvoicedAndDeliveredLines() {
    if (
      this.salesOrderLine.length > 0 &&
      this.salesOrderStatusD365?.toLowerCase() === "delivered"
    ) {
      //Check If Any line having delivered status
      const indexIfAnyLineDelivered = this.salesOrderLine.findIndex(
        x => x.salesOrderLine?.lineStatusD365?.toLowerCase() === "delivered"
      );

      //Check If IP associated
      const indexIfIpAccociated = this.salesOrderLine.findIndex(
        x => x.salesOrderLine?.proposalIdD365 !== ""
      );

      if (indexIfAnyLineDelivered !== -1 && indexIfIpAccociated !== -1) {
        this.isLineEditDisabled = true; //If check meets than need to show the add new line option on order lines gird
      }
    }
  }

  //OptimzationWork 27-02-2025
  ApiCallsOnSalesOrderEdit() {
    if (this.countryRegionList?.length <= 0) {
      this.getCountryRegionListData();
    }

    if (this.customerPaymentMethodList?.length <= 0) {
      this.getMehtodPaymentListData();
    }

    this.getAllBuyers();
    this.isCustomerPOFieldRequired(
      this.salesOrderHeaderData?.salesOrderHeader?.customerIdD365 ?? ""
    ); //OptimzationWork 27-02-2025
    this.getAllProgramsByCustomer(
      this.salesOrderHeaderData?.salesOrderHeader?.customerIdD365 ?? ""
    );
    this.getCustomerAccountDefaultDimensions(
      this.salesOrderHeaderData?.salesOrderHeader?.customerIdD365 ?? ""
    );

    // this.programs.getAllProgramDetailsByCustomerAccount(
    //   this.salesOrderHeaderData?.salesOrderHeader?.customerIdD365 ?? "",
    //   false
    // );
  }

  closeOrderSummaryModal() {
    this.closeOrderSummaryModalEvent.emit();
  }

  populateMenuItem() {
    this.items = [
      {
        label: "Print Project Confirmation",
        command: () => {
          this.printProjectConfirmation();
        },
      },
      {
        label: "Print Project Approval",
        command: () => {
          this.printProjectApproval();
        },
      },
      {
        label: "Print Order Summary",
        command: () => {
          this.printOrderSummary();
        },
      },
      {
        label: "Pro Forma Invoice",
        command: () => {
          this.openProFormaInvoice("proFormaInvoice");
        },
        visible:
          this.salesOrderLine.length > 0 &&
          this.salesOrderStatusD365 !== "Invoiced",
      },
      {
        label: "Deposit Invoice",
        command: () => {
          this.openProFormaInvoice("depositInvoice");
        },
        visible:
          this.salesOrderLine.length > 0 &&
          this.salesOrderStatusD365 !== "Invoiced",
      },
    ];
  }

  redirectToFreightEstimationPage() {
    this.showFreightEstimationModule = true;
  }

  closeFreightEstimationModule() {
    this.showFreightEstimationModule = false;
  }

  updateSelectedLineItems(selected: SaleOrderLineAddressDto[]) {
    this.selectedLineItems = selected;
  }

  refreshOrderSummaryPage() {
    this.ngOnInit();
  }

  getRemovedBacForSalesOrder(personnelNumber: string) {
    this._orderSummaryService
      .getEmployeeByPersonnelNumber(personnelNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data != null) {
            this.showBacUserInputField = true;
            this.removedBacUser =
              res.data.personnelNumber +
              " : " +
              res.data.firstName +
              " " +
              res.data.lastName;
          } else {
            this.showBacUserInputField = false;
          }
        },
      });
  }

  onClearShippingMethodSelection() {
    this.patchValueInAccount("");
  }

  patchValueInAccount(name: string) {
    this.saleOrderForm.patchValue({
      orderDetails: {
        account: name,
      },
    });
  }

  /**
   * Returns true when the currently selected shipping method is a
   * Nadel freight account (e.g. FedEx / UPS Nadel Account). In that case
   * the supplier account number must be auto-populated and non-editable.
   */
  get isNadelFreightAccount(): boolean {
    const shippingMethodCode = this.saleOrderForm?.get([
      "orderDetails",
      "shippingMethod",
    ])?.value;
    if (!shippingMethodCode || !this.shippingProductsList?.length) {
      return false;
    }
    const method = this.shippingProductsList.find(
      x => x.modeCodeD365 === shippingMethodCode
    );

    if (method?.useFreightAccountD365?.toLowerCase() !== "yes") {
      return false;
    }

    // Client requirement: only hide/lock the account number when the
    // shipping method is UPS or FedEx (Nadel freight accounts).
    const description = method?.modeDescriptionD365?.toLowerCase() ?? "";
    return description.includes("ups") || description.includes("fedex");
  }
}
